<template>
  <div>

    <div class="flex-spc-x fiex">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/vip/vip' }">{{WZHYName}}列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{WZHYName}}详情</el-breadcrumb-item>
      </el-breadcrumb>
        <el-link type="primary"  style="margin-right:0px"  @click="toVip()"><i class="el-icon-back"></i> 返回</el-link>
    </div>
    <!-- 搜索筛选 -->
    <div class="mainClass" style="padding-top:30px;margin-bottom:20px">
        <div class="flex-spc-x" style="width:100%">
            <div class="flexc-cen-x" style="margin-top:20px;width:28%;height:100px">
                <div class="">
                    <img :src="list.HeadUrl" v-if="list.HeadUrl !=''" style="width:80px;height:80px;border-radius:100%" alt="">
                    <img src="../../assets/img/head.png" v-if="list.HeadUrl ==''" style="width:80px;height:80px;border-radius:100%" alt="">
                </div>
                <div class="" style="margin-left:20px;height:80px">
                    <div class="flexc-cen-x" style="height:20px">
                        <div style="font-size:16px;font-weight:700">{{list.Name}}</div>
                        <img v-if="list.Sex == 2" src="../../assets/girl.png" style="margin-left:5px;width:20px;height:20px" alt="">
                        <img v-if="list.Sex == 1" src="../../assets/boy.png" style="margin-left:5px;width:20px;height:20px" alt="">
                    </div>
                    <div v-if="isCard == 0" style="font-size:15px;margin-top:20px">当前金额：￥{{list.czAmount}}</div>
                    <div v-if="isCard == 0" style="font-size:15px;margin-top:5px">当前次数：{{list.syNumber}}次</div>
                </div>
            </div>
            <div style="margin-left:20px;height:100px;margin-top:20px">
                <el-button size="mini" style="margin-top:10px" type="primary" v-if="isCard == 1 && w2 == true"    @click="toGiveCard">发卡</el-button>

                <el-button size="mini" type="danger"   @click="handleChong(1)" v-if=" isCard == 0 && q7 == true">充值金额</el-button>
                <el-button size="mini" type="warning"  @click="handleCi(1)" v-if="isCard == 0 && q8 == true" >充值次数</el-button>
                <el-button size="mini" style="margin-top:10px" type="success" v-if=" isCard == 0 &&w1 == true" @click="handleChong(0)">储蓄卡扣费</el-button>
                <el-button size="mini"  style="margin-top:10px" type="success" v-if="isCard == 0 && w1 == true" @click="handleCi(0)">次卡扣次</el-button>
                <el-button size="mini" style="margin-top:10px" type="warning" v-if="isCard == 0 &&list.Isdisablecx == 0 && w7 == true"  plain @click="closeCard(1)">储蓄卡禁用</el-button>
                <el-button size="mini" style="margin-top:10px" type="success" v-if="isCard == 0 &&list.Isdisablecx == 1 && w7 == true" plain @click="closeCard(0)">储蓄卡启用</el-button>
                <el-button size="mini" style="margin-top:10px" type="warning" v-if="isCard == 0 && list.Isdisableck == 0 && w7 == true" plain @click="sureCard(1)">次卡禁用</el-button>
                <el-button size="mini" style="margin-top:10px" type="success" v-if="isCard == 0 && list.Isdisableck == 1 && w7 == true "  plain @click="sureCard(0)">次卡启用</el-button>
                <el-button size="mini" style="margin-top:10px" type="warning" v-if="q11 == true"  @click="handlebang">微信解绑</el-button>
                <el-button size="mini" style="margin-top:10px" v-if="q2 == true" plain @click="handleEdit(list)">编辑</el-button>
                <el-button size="mini" style="margin-top:10px" v-if="q3 == true" type="info"  @click="delPerson()">删除</el-button>
                <el-button size="mini" style="margin-top:10px" type="info" v-if="isCard == 0 && w10 == true" plain @click="tojilu(2)">储蓄卡记录</el-button>  
                <el-button size="mini" style="margin-top:10px" type="info" v-if="isCard == 0 && w10 == true" plain @click="tojilu(1)">次卡记录</el-button>  
                <el-button size="mini" style="margin-top:10px" type="info" v-if="isCard == 0 && w10 == true" plain @click="tochongji()">充值记录</el-button>  
                <el-button size="mini" style="margin-top:10px"  type="primary" v-if="q4  == true && issjjhcf==0" @click="editZi()">添加子账号</el-button>
            </div>
        </div>
        <div class="title" style="margin-top:12px;font-size:12px;color:#808080">基本信息</div>
        <div class="diss"  style="width:100%;margin-top:15px">
            <div class="tiao">
                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                    <div class="labele">{{WZHYName}}编号</div>
                    <div class="labele">{{list.MemberCard}}</div>
                </div>
            </div>
            <div class="tiao">
                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                    <div class="labele">登记日期</div>
                    <div class="labele">{{list.OpenTime}}</div>
                </div>
            </div>
            <div class="tiao" v-if="isdengji == 1">
                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                    <div class="labele">{{WZHYName}}等级</div>
                    <div class="labele">{{list.LevelName}}</div>
                </div>
            </div>
            <div class="tiao">
                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                    <div class="labele">电话</div>
                    <div class="labele">{{list.Phone}}</div>
                </div>
            </div>
            <div class="tiao">
                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                    <div class="labele">生日</div>
                    <div class="labele" v-if="list.Birthday !=''">{{list.Birthday}}</div>
                    <div class="labele" v-else>未知</div>
                </div>
            </div>
            <div class="tiao">
                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                    <div class="labele">地址</div>
                    <div class="labele">{{list.Address}}</div>
                </div>
            </div>
             <div class="tiao">
                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                    <div class="labele">业务员</div>
                    <div class="labele" >{{list.StaffName}}</div>
                 
                </div>
            </div>
            <div class="tiao" v-if="isjifen == 1">
                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                    <div class="labele">积分</div>
                    <div class="labele" >{{list.Integral}}</div>
                 
                </div>
            </div>
        </div>
    
        <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top:20px;padding-bottom:20px">
            <el-tab-pane label="会员卡信息" name="0" v-if=" isCard == 1">
              <div class="cardMain" style="width:100%">
                <div class="flex-spc-x " v-for="(items,index) in cardList" style="margin-top:20px">
                    <div class="flex-xy card cursor" @click="toMain(items)">
                        <img :src="items.CradImg" style="height:65px;border-radius:5px" alt="">
                        <div class="coBlue" style="font-size:14px;margin-top:5px">查看详情</div>
                    </div>
                    <div style="width:79%">
                        <div class="flex-spc-x" style="width:100%;">
                            <div class="tiao">
                                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                                    <div class="labele">名称</div>
                                    <div class="labele">{{items.CardName}}</div>
                                </div>
                            </div>
                            <div class="tiao">
                                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                                    <div class="labele">类型</div>
                                    <div class="labele" v-if="items.CardType == 1">次卡（有期限）</div>
                                    <div class="labele" v-if="items.CardType == 2">次卡（无限期）</div>
                                    <div class="labele" v-if="items.CardType == 3">期限卡（不限次数）</div>
                                    <div class="labele" v-if="items.CardType == 4">储蓄卡（无期限）</div>
                                    <div class="labele" v-if="items.CardType == 5">储蓄卡（有期限）</div>
                                </div>
                            </div>
                        </div>
                        <div class="flex-spc-x" style="width:100%;">
                            <div class="tiao">
                                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                                    <div class="labele" v-if="items.CardType == 1 || items.CardType == 2|| items.CardType == 3">可用次数</div>
                                    <div class="labele" v-if="items.CardType == 3">不限次数</div>
                                    <div class="labele" v-if="items.CardType == 2||items.CardType == 1">{{items.CardNumber}}次</div>
                                    <div class="labele" v-if="items.CardType == 4 || items.CardType == 5">可用金额</div>
                                    <div class="labele" v-if="items.CardType == 4||items.CardType == 5">{{items.Amount}}元</div>
                                </div>
                            </div>
                            <div class="tiao">
                                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                                    <div class="labele">到期时间</div>
                                    <div class="labele" v-if="items.CardType == 2 || items.CardType == 4">无期限</div>
                                    <div class="labele" v-if="items.CardType != 2 && items.CardType != 4">{{items.OverdueTime}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="flex-spc-x" style="width:100%;">
                            <!-- <div class="tiao">
                              <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                              <div class="labele" v-if="items.CardType == 1 || items.CardType == 2|| items.CardType == 3">购买次数</div>
                                    <div class="labele" v-if="items.CardType == 3">不限次数</div>
                                    <div class="labele" v-if="items.CardType == 2||items.CardType == 1">{{items.CardNumber}}次</div>
                                    <div class="labele" v-if="items.CardType == 4 || items.CardType == 5">购买金额</div>
                                    <div class="labele" v-if="items.CardType == 4||items.CardType == 5">{{items.Amount}}元</div>
                              </div>
                              </div> -->
                              <div class="tiao">
                                <div class="flex-spc-x" style="height:100%;padding-left:10px;padding-right:10px">
                                    <div class="labele">状态</div>
                                    <div class="flexc-cen-x">
                                      <el-badge value="正常" type="success" v-if="items.Isdisable =='0'"></el-badge>
                                      <el-badge value="禁用" type="info" v-if="items.Isdisable =='1'"></el-badge>
                                      <el-badge value="未开卡" type="info" v-if="items.iskaika =='0'"></el-badge>
                                      <el-badge value="已开卡" type="success" v-if="items.iskaika =='1'"></el-badge>
                                      <el-badge value="已停卡" type="error" v-if="items.isStop =='1'"></el-badge>    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-xy" style="width:100%;margin-top:15vh"  v-if="cardList.length == 0">
                  <img src="../../assets/zanwu.png" alt="" style="width:100px;height:100px">
                  <div style="color:#808080">暂无数据</div>
               </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="nmae1+'预约记录'" name="1"  v-if="iszjyy == 1">
              <div class="cardMain" style="width:100%">
                <el-table :data="PreZJList" highlight-current-row v-loading="loading" size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
                  <el-table-column  prop="yyTime" label="预约时间"  >
                  </el-table-column>
                  <el-table-column  prop="ProjectName" :label="WZXMName+'名称'" >
                    
                  </el-table-column>
                    <el-table-column  prop="StoresName" label="门店" align="center" >
                    </el-table-column>
                    <el-table-column  prop="vipName" label="预约方式" align="center" >
                      <template slot-scope="scope">
                        <div v-if="scope.row.isZF  == 1 " >
                          线上支付
                        </div>
                        <div  v-if="scope.row.isZF == 0 && scope.row.vipID == 0">
                         无卡预约
                        </div>
                         <div    v-if="scope.row.isZF == 0 && scope.row.vipID != 0">
                            会员卡支付({{scope.row.vipName}})
                        </div>
                      </template>
                   
                    </el-table-column>
                    <el-table-column  prop="vipName" label="扣除" align="center" >
                       <template slot-scope="scope">
                        <div v-if="scope.row.isZF == 0 && scope.row.vipID == 0" >
                            无
                        </div>
                        <div  v-if="scope.row.isZF  == 1">
                            {{scope.row.PayAmount}}元
                        </div>
                         <div    v-if="scope.row.isZF != 1 && !(scope.row.isZF == 0 && scope.row.vipID == 0)">
                          {{scope.row.vipvaule}}
                        </div>
                      </template>
                    </el-table-column>
                    
                  <!-- <el-table-column  prop="Phone" label="联系电话"  align="center">
                  </el-table-column> -->
                  <el-table-column  prop="state" label="状态" align="center">
                          <template slot-scope="scope">
                            <span class="Info" v-if="scope.row.state == 0">
                              学员取消
                            </span>
                            <span class="coBlue" v-if="scope.row.state == 1">
                              已预约
                            </span>
                            <span class="Success" v-if="scope.row.state == 2">
                              已{{name}}
                            </span>
                            <span class="Danger" v-if="scope.row.state == 3">
                              未到
                            </span>
                            <span class="Info" v-if="scope.row.state == 4">
                              机构取消
                            </span>
                            <span class="Warning" v-if="scope.row.state == 5">
                              请假
                            </span>
                          </template>
                  </el-table-column>
                </el-table>
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather1"></Pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="WZPBName+'预约记录'" name="2" v-if="ispaiban == 1">
                <div class="cardMain" style="width:100%">
                  <el-table  :data="preList" highlight-current-row v-loading="loading" size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
                    <el-table-column  prop="startTimeNew" :label="WZXMName+'日期'"  >
                      <template slot-scope="scope">
                        <div class="flexc-cen-x">
                          {{scope.row.SKtime}}  {{scope.row.startTimeNew}}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column  prop="TcStaffTypeID" :label="WZXMName+'名称'"  >
                      <template slot-scope="scope">
                      
                          <div class="flexc-cen-x">
                            <img :src="scope.row.ProjectHeadUrl" style="width:25px;height:25px;border-radius:100%" alt="">
                            <div style="margin-left:5px;font-size:13px">{{scope.row.ProjectName}}</div>
                          </div>
                    

                      </template>
                    </el-table-column>

                    <el-table-column  prop="SiteName" :label="WZCDName"  v-if="IsCD == 1" align="center" >
                    </el-table-column>
                    <el-table-column  prop="terName" label="服务人员" align="center" >
                    </el-table-column>
                    <el-table-column  prop="state" label="状态" align="center">
                          <template slot-scope="scope">
                            <span class="Info" v-if="scope.row.state == 0">
                              学员取消
                            </span>
                            <span class="coBlue" v-if="scope.row.state == 1">
                              已预约
                            </span>
                            <span class="Success" v-if="scope.row.state == 2">
                              已{{name}}
                            </span>
                            <span class="Danger" v-if="scope.row.state == 3">
                              未到
                            </span>
                            <span class="Info" v-if="scope.row.state == 4">
                              机构取消
                            </span>
                            <span class="Warning" v-if="scope.row.state == 5">
                              请假
                            </span>
                          </template>
                    </el-table-column>
                    <!-- <el-table-column  prop="terName" label="次数" align="center" >
                    </el-table-column> -->
                    <el-table-column  prop="vipName" label="预约方式" align="center" >
                      <template slot-scope="scope">
                        <div v-if="scope.row.isZF  == 1 " >
                          线上支付
                        </div>
                        <div  v-if="scope.row.isZF == 0 && scope.row.vipID == 0">
                         无卡预约
                        </div>
                         <div    v-if="scope.row.isZF == 0 && scope.row.vipID != 0">
                            会员卡支付({{scope.row.vipName}})
                        </div>
                      </template>
                   
                    </el-table-column>
                    <el-table-column  prop="vipName" label="扣除" align="center" >
                       <template slot-scope="scope">
                        <div v-if="scope.row.isZF == 0 && scope.row.vipID == 0" >
                            无
                        </div>
                        <div  v-if="scope.row.isZF  == 1">
                            {{scope.row.PayAmount}}元
                        </div>
                         <div    v-if="scope.row.isZF != 1 && !(scope.row.isZF == 0 && scope.row.vipID == 0)">
                          {{scope.row.vipvule}}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column  prop="PreAboutCount" label="人数" align="center" >
                    </el-table-column>
          <el-table-column  prop="StoresName" label="门店" align="center" >
            </el-table-column>
                  </el-table>
                </div>
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather1"></Pagination>
            </el-tab-pane>
            <el-tab-pane label="订单记录" name="3" v-if="isCashier == 1">          
              <div class="cardMain" style="width:100%">
                <el-table  :data="orderList" highlight-current-row v-loading="loading" size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
                <el-table-column  prop="OrderCode" label="订单号"  align="center">
              </el-table-column>
              <el-table-column  prop="TcStaffTypeID" label="订单价格" align="center" >
                <template slot-scope="scope">
                  <div class="flex-xy">
                      ￥{{scope.row.OrderPrice}} 
                  </div>
                </template>
              </el-table-column>
              <el-table-column  prop="SFPrice" label="实付金额" align="center" >
                <template slot-scope="scope">
                  <div class="flex-xy">
                      ￥{{scope.row.SFPrice}} 
                  </div>
                </template>
              </el-table-column>
              <el-table-column  prop="YHPrice" label="优惠金额"  align="center">
                <template slot-scope="scope">
                  <div class="flex-xy">
                      ￥{{scope.row.YHPrice}} 
                  </div>
                </template>
              </el-table-column>
              <el-table-column  prop="MaLingPrice" label="抹零金额"  align="center">
                <template slot-scope="scope">
                  <div class="flex-xy">
                      ￥{{scope.row.MaLingPrice}} 
                  </div>
                </template>
              </el-table-column>
              <el-table-column  prop="StoresName" label="门店" align="center" >
            </el-table-column>
              <el-table-column  prop="addTime" label="下单时间" align="center" >
              </el-table-column>
              <!-- <el-table-column  prop="state" label="状态" align="center" >
              </el-table-column> -->
              <!-- <el-table-column  prop="StaffName" label="业务归属" align="center" >
              </el-table-column> -->
              <el-table-column  prop="Note" label="备注" align="center" >
              </el-table-column>

                </el-table>
              </div>
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather1"></Pagination>
            </el-tab-pane>
            <el-tab-pane label="子账号" name="4" v-if="q10 == true  && issjjhcf==0">
              <div class="cardMain" style="width:100%">
                <el-table  :data="subList" highlight-current-row v-loading="loading" size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
                  <el-table-column  prop="Name" label="姓名"  >
                  </el-table-column>
                  <el-table-column  prop="Phone" label="电话"  >
                  
                  </el-table-column>

                  <el-table-column  prop="Note" label="备注" >
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="200"  fixed="right" >
                    <template slot-scope="scope">
                      <el-button size="mini" v-if="q5 == true" @click="editZi(scope.row)">编辑</el-button>
                      <el-button size="mini" v-if="q6 == true" type="info" @click="deleteSub(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="积分记录" name="5" v-if="isjifen == 1">
              <div class="w100 flex-spc-x">
                <div class=""> 
                  <el-select v-model="typeName" filterable  @change="changeType"   size="small">
                    <el-option v-for="item in jfList" :label="item.name" :key="item.ID" :value="item.ID">
                    </el-option>
                  </el-select>
                </div>
                <div>    
                  <el-button size="mini" style="margin-top:10px" type="info"  plain @click="tozeng()">赠送积分</el-button>  
                  <el-button size="mini" style="margin-top:10px"  type="primary"  @click="todui()">兑换积分</el-button>
                </div>
              </div>
            
                <div class="cardMain" style="width:100%">
                  <el-table  :data="jifenList" highlight-current-row v-loading="loading" size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
                  <el-table-column  prop="Integral" label="积分" >
                </el-table-column>
                    <el-table-column  prop="Note" label="备注" align="center" >
                </el-table-column>
                <el-table-column  prop="loginname" label="操作人" align="center" >
                </el-table-column>
                <el-table-column  prop="addtime" label="操作时间" align="center" >
                
                </el-table-column>

                <el-table-column  prop="StoresName" label="门店" align="center" >
              </el-table-column>


                <!-- <el-table-column  prop="StaffName" label="业务归属" align="center" >
                </el-table-column> -->


                  </el-table>
                </div>
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather1"></Pagination>
            </el-tab-pane>
            <el-tab-pane label="优惠券列表" name="6" v-if="isyhq == 1">
              <div class="w100 flex-spc-x">
                <div class=""> 
                  <el-select v-model="yhq" filterable  @change="changeyhqType"   size="small">
                    <el-option v-for="item in yhqType" :label="item.name" :key="item.ID" :value="item.ID">
                    </el-option>
                  </el-select>
                </div>
                <div>    
                  <el-button size="mini" style="margin-top:10px" type="info"  plain @click="tozengTc()">赠送优惠券</el-button>  
              
                </div>
              </div>
            
                <div class="cardMain" style="width:100%">
                  <el-table  :data="yhqList" highlight-current-row v-loading="loading" size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
                      <el-table-column  prop="CouponActivityinfo.Title" label="优惠券名称">
                      </el-table-column>
                      <el-table-column  prop="CouponActivityinfo.DDPrice" label="订单价格" align="center" >
                      </el-table-column>
                      <el-table-column  prop="preferentialType" label="优惠类别" align="center" >
                        <template slot-scope="scope">
                          <div class="flex-xy">
                            <div v-if="scope.row.CouponActivityinfo.preferentialType == 2 " style="margin-top:5px;">减免</div>
                            <div v-if="scope.row.CouponActivityinfo.preferentialType == 1 " style="margin-top:5px;">打折</div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column   prop="CouponActivityinfo.addTime" label="优惠" align="center">
                        <template slot-scope="scope">
                          <div class="flex-xy">
                            <div v-if="scope.row.CouponActivityinfo.preferentialType == 2 " style="margin-top:5px;">{{scope.row.CouponActivityinfo.preferentialvalue}}元</div>
                            <div v-if="scope.row.CouponActivityinfo.preferentialType == 1 " style="margin-top:5px;">{{scope.row.CouponActivityinfo.preferentialvalue*10}}折</div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column  prop="CardName" label="使用会员卡" v-if="yhq == 2" >
                      </el-table-column>
                      <el-table-column  prop="CouponActivityinfo.startTime" label="开始时间" >
                      </el-table-column>
                      <el-table-column  prop="CouponActivityinfo.endTime" label="结束时间" >
                      </el-table-column>
                      <el-table-column align="center" label="操作">
                            <template template slot-scope="scope">
                              <el-button  v-if="yhq != 2 " type="info" plain size="mini" @click="handlejie(scope.row)">作废</el-button>
                              <el-button v-if="yhq != 2" size="mini" type="info" @click="deleteYhq(scope.row)">删除</el-button>
                            </template>
                      </el-table-column>
                  </el-table>
                </div>
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather1"></Pagination>
            </el-tab-pane>
        </el-tabs>
    </div>
    <el-drawer :wrapperClosable= false :title="title" :visible.sync="cardShow" :direction="direction" size="40%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
      <el-form label-width="120px" :model="ruleForm" :rules="rules" ref="ruleForm" style="padding-bottom:100px">
        <el-form-item label="选择会员卡："  prop="CardID">
              <el-select v-model="ruleForm.CardName" filterable  @change="changeCardID1"  placeholder="请选择会员卡"  size="small">
                  <el-option v-for="item in typeList" :key="item.index" :label="item.CardName +'/￥'+item.SellingPrice "  :value="item.ID+','+item.CardType+','+item.CardName+','+item.Kynumber+','+item.yxdays +','+item.Amount+','+item.SellingPrice +','+item.dayType + ','+item.daysvalue"  >
                  </el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="是否开卡：">
                             <el-radio-group v-model="ruleForm.iskaika" >
                                <el-radio label="1">立即开卡</el-radio>
                                <el-radio label="0">暂不开卡</el-radio>
                                <el-radio   label="2">首次预约开卡</el-radio>
                            </el-radio-group>
         </el-form-item>
          <el-form-item label="开卡日期："  v-if="showCardNum  && !isEdit && ruleForm.iskaika =='1'" prop="KaiKaTime">
                        <el-date-picker
                        size="small"
                            v-model="ruleForm.KaiKaTime"
                            align="right"
                            type="date"
                            value-format="yyyy-MM-dd"
                            @change='selectData1(ruleForm)'
                            placeholder="请选择开卡日期">
                        </el-date-picker>
          </el-form-item>

                    <el-form-item label="会员编号：" v-if="showCardNum && !isEdit && khIson=='1'" prop="CardNum">
                        <el-input v-model="ruleForm.CardNum" placeholder="请输入会员编号" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="购买次数："  v-if="showKynumber && !isEdit" prop="buyCount" >
                        <el-input v-model="ruleForm.buyCount" placeholder="购买次数" style="width:100px;" size="small"></el-input> 次
                    </el-form-item>
                    <el-form-item label="当前可用次数："  v-if="showKynumber && !isEdit" prop="CardNumber" >
                        <el-input v-model="ruleForm.CardNumber" placeholder="当前可用次数" style="width:100px;" size="small"></el-input> 次
                    </el-form-item>
                    <el-form-item label="赠送次数："  v-if="showKynumber && !isEdit" prop="zsCardNumber" >
                        <el-input v-model="ruleForm.zsCardNumber" placeholder="当前赠送次数：" style="width:100px;" size="small"></el-input> 次
                    </el-form-item>
                    <el-form-item label="期限类型：" v-if="showCardNum  && !isEdit && ruleForm.iskaika =='1' && (ruleForm.CardType==1 || ruleForm.CardType==3 || ruleForm.CardType==5)">
                        <span v-if="ruleForm.dayType == 1">{{ruleForm.daysvalue}}日</span>
                         <span v-if="ruleForm.dayType == 2">{{ruleForm.daysvalue}}月</span>
                          <span v-if="ruleForm.dayType == 3">{{ruleForm.daysvalue}}年</span>
                    </el-form-item>

                    <el-form-item  v-if="showCardNum  && !isEdit && ruleForm.iskaika =='1' && (ruleForm.CardType==1 || ruleForm.CardType==3 || ruleForm.CardType==5)" label="赠送期限类别:">
            <el-radio-group v-model="ruleForm.zsdayType" v-on:input="inputSubtotal1(ruleForm)">
              <el-radio :label="1">天</el-radio>
              <el-radio :label="2">月</el-radio>
              <el-radio :label="3">年</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="赠送期限值:"  v-if="showCardNum  && !isEdit && ruleForm.iskaika =='1' && (ruleForm.CardType==1 || ruleForm.CardType==3 || ruleForm.CardType==5)" prop="zsdaysvalue">
              <!-- <el-input-number v-model="ruleForm.zsdaysvalue" :step="1" step-strictly size="small"></el-input-number> -->
              <el-input v-model="ruleForm.zsdaysvalue" v-on:input="inputSubtotal1(ruleForm)" placeholder="赠送期限值" style="width:100px;"></el-input> 

              <span style="margin-left:5px" v-if="ruleForm.zsdayType == 1">天</span>
              <span style="margin-left:5px" v-if="ruleForm.zsdayType == 2">月</span>
              <span style="margin-left:5px" v-if="ruleForm.zsdayType == 3">年</span>
        </el-form-item>

                    <el-form-item label="到期时间："  v-if="showCardNum  && !isEdit && ruleForm.iskaika =='1' && (ruleForm.CardType==1 || ruleForm.CardType==3 ||ruleForm.CardType==5 )" prop="EndTime">
                         <span>{{ruleForm.EndTime}}</span>
                    </el-form-item>
                    <el-form-item label="充值金额："  v-if="showAmount && !isEdit" prop="Amount" >
                        <el-input size="small" v-model="ruleForm.Amount" placeholder="充值金额" style="width:100px;"></el-input> 元
                    </el-form-item>
                    <el-form-item label="赠送金额："  v-if="showAmount && !isEdit" prop="zsAmount" >
                        <el-input size="small" v-model="ruleForm.zsAmount" placeholder="赠送金额" style="width:100px;"></el-input> 元
                    </el-form-item>
                    
                    <el-form-item size="small" label="应收金额："  v-if="showPurchaseAmount && !isEdit" prop="YSAmount">
                         <!-- <el-input v-model="ruleForm.YSAmount"  placeholder="应收金额" style="width:100px;" v-if="isshowGM == 1"></el-input>  -->
                         <!-- <span v-if="isshowGM == 0">{{ruleForm.YSAmount}}</span> -->
                         <el-input v-model="ruleForm.YSAmount"  placeholder="应收金额" style="width:100px;" ></el-input> 

                        <span>元</span>

                    </el-form-item>
                    <el-form-item size="small" label="实付金额："  v-if="showPurchaseAmount && !isEdit" prop="PurchaseAmount" >
                        <!-- <el-input v-model="ruleForm.PurchaseAmount" placeholder="实付金额" style="width:100px;" v-if="isshowGM == 1"></el-input> 
                        <span v-if="isshowGM == 0">{{ruleForm.PurchaseAmount}}</span> -->

                         <el-input v-model="ruleForm.PurchaseAmount" placeholder="实付金额" style="width:100px;" ></el-input> 

                        <span>元</span>
                   
                    </el-form-item>
                    <el-form-item label="售卡时间：" v-if="!isEdit && ruleForm.Isbangka=='1'" prop="GMtime">
                        <el-date-picker
                            size="small"
                            v-model="ruleForm.GMtime"  
                            align="right"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择售卡时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="折扣："  v-if="showAmount && !isEdit && iscxjk == 1 && w12 == true" prop="Amount" >
                      <el-input-number v-model="zhekou" :precision="1" :step="0.1" :max="10" :min="0" size="small"></el-input-number> 折 <span style="color:#808080">(0表示无折扣)</span>
                    </el-form-item>
                    <el-form-item  label="业务归属人：" v-if="!isEdit && ruleForm.Isbangka=='1'" prop="LoginID">
                          <span>{{personName}}</span>
                        <el-button @click="handlePassword1()" type="text">添加</el-button>
                        <el-button v-if="personName!=''"  @click="toDelPer()" icon="el-icon-delete"  type="text" style="margin-left:30px"></el-button>
                    </el-form-item>
                    <el-form-item label="使用优惠券：" v-if="isyhq == 1" prop="isyhq">
                        <el-radio-group v-model="ruleForm.isyhq">
                              <el-radio label="1">是</el-radio>
                              <el-radio label="0">否</el-radio>
                        </el-radio-group>
                   </el-form-item>
                    <el-form-item label="选择优惠券：" v-if="ruleForm.isyhq == 1 &&  isyhq == 1 ">
                      <el-input placeholder="选择优惠券" size="small" :disabled="true" v-model="myyhq.CouponActivityinfo.Title" style="width:200px" ></el-input>
                       <el-button style="margin-left:10px" type="primary" size="mini" @click="chooseMyYhq">选择优惠券</el-button>
                    </el-form-item>
                    <el-form-item size="small" label="优惠后金额："  v-if="myyhq.CouponActivityinfo.Title" prop="PurchaseAmount" >
                        <span>{{yhmoney}}</span>
                        <span>元</span>
                    </el-form-item>
                    <el-form-item label="备注：" prop="Note" style="width:90%">
                        <el-input type="textarea" v-model="ruleForm.Note"></el-input>
                    </el-form-item>
        
        </el-form>

        <div class="demo-drawer__footer flex-r-x" style="width:40%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
            style="margin-right:20px"
            size="small"
            type="primary"
            @click="submitForm('ruleForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>
    <el-drawer :wrapperClosable= false title="会员卡详情" :visible.sync="cardMain" :direction="direction" size="50%">
        <div class="memberLine" style="padding-left:5%">
                                <p>
                                    <span class="brandTitle">{{vipitem.CardName}}</span>
                                    <el-badge value="正常" type="success" v-if="vipitem.Isdisable =='0'"></el-badge>
                                    <el-badge value="禁用" type="info" v-if="vipitem.Isdisable =='1'"></el-badge>
                                    <el-badge value="未开卡" type="info" v-if="vipitem.iskaika =='0'"></el-badge>
                                    <el-badge value="已开卡" type="success" v-if="vipitem.iskaika =='1'"></el-badge>
                                     <el-badge value="已停卡" type="error" v-if="vipitem.isStop =='1'"></el-badge>    
                                    <el-button size="mini"  v-if="vipitem.CardType !='3' && w1 == true" type="primary" @click="xiaokeClick(vipitem)">{{name2}}</el-button>
                                    <el-button size="mini" type="primary" v-if="w3 == true" @click="xukaClick(vipitem)">续卡</el-button>
                                    <el-button size="mini" v-if="w10 == true" type="default" plain @click="getYeList(vipitem)" >订单记录</el-button>
                                    <el-button size="mini" v-if="w10 == true" type="default" plain @click="giveCardList(vipitem)" >操作记录</el-button>
                                </p>
                                <p>
                                 <span class="subTitle">
                                        <label>备注：</label>
                                        <label>{{vipitem.Note}}</label>
                                    </span>
                                </p>  <br>
                                  <div style="width:400px;height:100px;display:table">
                                    <div style="width:150px;height:100px;display:table-cell">
                                      <!-- <span>门店：{{vipitem.StoresName}}</span>  <br>                          -->
                                      <span>业务归属人：{{vipitem.sourceName}}</span>   <br>                  
                                      <span v-if="vipitem.iskaika =='1'">开卡时间：{{vipitem.KaiKaTime}}</span> 
                                      <span v-if="khIson=='1'">卡号：{{vipitem.CardNum}}</span><br>  

                                    </div>
                                  <div style="width:150px;height:100px;display:table-cell">
                                      <span  v-if="vipitem.CardType =='1'">剩余次数：{{vipitem.CardNumber}}</span>  
                                      <span  v-if="vipitem.CardType =='2'">剩余次数：{{vipitem.CardNumber}}</span>  
                                      <span  v-if="vipitem.CardType =='3'">剩余次数：不限次数</span>  
                                      <span  v-if="vipitem.CardType =='4'">剩余金额：{{vipitem.Amount}}</span>  
                                      <span  v-if="vipitem.CardType =='5'">剩余金额：{{vipitem.Amount}}</span>          
                                      <br>
                                         <span v-if="vipitem.GMtime != ''" >发卡时间：{{vipitem.GMtime}}</span>    
                                      <br>              
                                      <span v-if="vipitem.iskaika =='1' && vipitem.CardType =='1'">到期时间：{{vipitem.OverdueTime}}</span>    
                                      <span v-if="vipitem.CardType =='2'">到期时间：无限期</span>    
                                      <span v-if="vipitem.iskaika =='1' && vipitem.CardType =='3'">到期时间：{{vipitem.OverdueTime}}</span>    
                                      <span v-if="vipitem.CardType =='4'">到期时间：无限期</span>    
                                      <span v-if="vipitem.iskaika =='1' && vipitem.CardType =='5'">到期时间：{{vipitem.OverdueTime}}</span>    
                                    <br>
                                  </div>
                                </div>
                                <div>
                                    <el-button  type="text" @click="delMembersvipClick(vipitem.ID)" v-if="w11 == true" >删除</el-button>
                                    <el-button type="text" @click="editMembersvipNoteClick(vipitem)"  v-if="w4 == true" >备注</el-button>
                                    <el-button type="text" @click="editMembersvipCardNumberClick(vipitem)"  v-if="w5 == true && vipitem.CardType =='1' || vipitem.CardType =='2'">修改次数</el-button>
                                    <el-button type="text" @click="editMembersvipCardDaysClick(vipitem)"   v-if="w6 == true && vipitem.iskaika =='1' &&(vipitem.CardType =='1'|| vipitem.CardType =='3'|| vipitem.CardType =='5')">修改到期时间</el-button>
                                    <el-button type="text" @click="editMembersvipAmounteClick(vipitem)"   v-if="vipitem.CardType =='4' || vipitem.CardType =='5'">修改金额</el-button>
                                    <el-button type="text" @click="editzhe(vipitem)"   v-if="(vipitem.CardType =='4' || vipitem.CardType =='5')&& iscxjk ==1 && w12 == true">修改折扣</el-button>
                                    <el-button type="text" @click="editMembersvipIsdisableClick(vipitem.ID)"   v-if="vipitem.Isdisable =='0' && w7 == true">禁用</el-button>
                                    <el-button type="text" @click="editMembersvipIsdisableClick1(vipitem.ID)"   v-if="vipitem.Isdisable =='1' && w7 == true">启用</el-button>
                                    
                                    <el-button type="text" @click="editMembersvipisStopClick(vipitem)"   v-if="w8 == true && vipitem.isStop =='0' && (vipitem.CardType =='1' || vipitem.CardType =='3'||vipitem.CardType =='5')">停卡</el-button>
                                    <el-button type="text" @click="editMembersvipisStopClick1(vipitem)"   v-if="w8 == true && vipitem.isStop =='1' && (vipitem.CardType =='1' || vipitem.CardType =='3'||vipitem.CardType =='5')">解除停卡</el-button>

                                    <el-button type="text" @click="editMembersvipiskaikaClick(vipitem)"   v-if="w9 == true && vipitem.iskaika =='0'">开卡</el-button>
                                    <el-button type="text" @click="editMembersvipiskaikaClick(vipitem)"   v-if="w9 == true &&vipitem.iskaika =='1'">修改开卡时间</el-button>
                                    <el-button type="text" @click="editMembersvipCardNumClick(vipitem)"   v-if="khIson =='1'">修改会员卡卡号</el-button>
                                     <el-button type="text" @click="editMembersvipweekdaysClick(vipitem)"   v-if="isweekdays =='1' &&  vipitem.CardType =='3'">设置预约次数</el-button>
                                     <el-button type="text" @click="addvipJYZQClick(vipitem)" >设置周期限制</el-button>

                                </div>
                                <br>
        </div>
        <el-tabs v-model="activeName1" @tab-click="handleClick1" style="margin-top:20px;padding-bottom:20px;padding-left:10px">
            <el-tab-pane :label="WZPBName+name+'记录'" name="0"  v-if="ispaiban==1">
                  <el-table :data="hexiaoList" highlight-current-row v-loading="loading" size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
                  <el-table-column  prop="yyTime" :label="WZXMName+'时间'" width="150">
                     <template slot-scope="scope">
                       <span>{{scope.row.SKtime}} {{scope.row.startTimeNew}}</span>
                     </template>
                  </el-table-column>
                  <el-table-column  prop="ProjectName" :label="WZXMName+'名称'" >
                  </el-table-column>
                  <el-table-column  prop="terName" :label="WZYGName" >
                  </el-table-column>
                  <el-table-column  prop="state" label="扣卡" align="center">
                    <template slot-scope="scope">
                      <span class="Info" v-if="vipitem.CardType =='1'||vipitem.CardType =='2'">
                          {{scope.row.CardNumber}}次
                      </span>
                      <span class="Info" v-if="vipitem.CardType =='3'">
                          无
                      </span>
                      <span class="Info" v-if="vipitem.CardType =='4'||vipitem.CardType =='5'">
                          {{scope.row.Amount}}元
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column  prop="PreAboutCount" label="预约人数" align="center" >
                  </el-table-column>
                    <el-table-column  prop="StoresName" label="门店" align="center" >
                    </el-table-column>
                  <el-table-column  prop="state" label="状态" align="center">
                          <template slot-scope="scope">
                            <span class="Info" v-if="scope.row.state == 0">
                              学员取消
                            </span>
                            <span class="coBlue" v-if="scope.row.state == 1">
                              已预约
                            </span>
                            <span class="Success" v-if="scope.row.state == 2">
                              已{{name}}
                            </span>
                            <span class="Danger" v-if="scope.row.state == 3">
                              未到
                            </span>
                            <span class="Info" v-if="scope.row.state == 4">
                              机构取消
                            </span>
                            <span class="Warning" v-if="scope.row.state == 5">
                              请假
                            </span>
                          </template>
                  </el-table-column>
                  </el-table>
                  <Pagination v-bind:child-msg="pageparm" @callFather="callFather11"></Pagination>
            </el-tab-pane>
            <el-tab-pane :label="nmae1+name+'记录'" name="1" v-if="iszjyy == 1" >
    
                  <el-table :data="hexiaoList" highlight-current-row v-loading="loading" size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
                  <el-table-column  prop="yyTime" label="预约时间" width="150">
                   
                  </el-table-column>
                  <el-table-column  prop="ProjectName" :label="WZXMName+'名称'" >
                  </el-table-column>

                  <el-table-column  prop="state" label="扣卡" align="center">
                    <template slot-scope="scope">
                      <span class="Info" v-if="vipitem.CardType =='1'||vipitem.CardType =='2'">
                          {{scope.row.CardNumber}}次
                      </span>
                      <span class="Info" v-if="vipitem.CardType =='3'">
                          无
                      </span>
                      <span class="Info" v-if="vipitem.CardType =='4'||vipitem.CardType =='5'">
                          {{scope.row.Amount}}元
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column  prop="PreAboutCount" label="预约人数" align="center" >
                  </el-table-column>
                    <el-table-column  prop="StoresName" label="门店" align="center" >
                    </el-table-column>
                  <el-table-column  prop="state" label="状态" align="center">
                          <template slot-scope="scope">
                            <span class="Info" v-if="scope.row.state == 0">
                              学员取消
                            </span>
                            <span class="coBlue" v-if="scope.row.state == 1">
                              已预约
                            </span>
                            <span class="Success" v-if="scope.row.state == 2">
                              已{{name}}
                            </span>
                            <span class="Danger" v-if="scope.row.state == 3">
                              未到
                            </span>
                            <span class="Info" v-if="scope.row.state == 4">
                              机构取消
                            </span>
                            <span class="Warning" v-if="scope.row.state == 5">
                              请假
                            </span>
                          </template>
                  </el-table-column>
                  </el-table>
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather11"></Pagination>
  
            </el-tab-pane>
                <el-tab-pane :label="WZCDName+name+'记录'" name="4"  v-if="iscdyy==1">
                  <el-table :data="hexiaoList" highlight-current-row v-loading="loading" size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
                  <el-table-column  prop="yyTime" :label="'预约时间'" width="250">
                     <template slot-scope="scope">
                       <span>{{scope.row.yyTime}} {{scope.row.sTime +'~'+ scope.row.eTime}}  </span>
                     </template>
                  </el-table-column>
                  <el-table-column  prop="SiteName" :label="WZCDName+'名称'" >
                  </el-table-column>
               
                  <el-table-column  prop="state" label="扣卡" align="center">
                    <template slot-scope="scope">
                      <span class="Info" v-if="vipitem.CardType =='1'||vipitem.CardType =='2'">
                          {{scope.row.CardNumber}}次
                      </span>
                      <span class="Info" v-if="vipitem.CardType =='3'">
                          无
                      </span>
                      <span class="Info" v-if="vipitem.CardType =='4'||vipitem.CardType =='5'">
                          {{scope.row.Amount}}元
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column  prop="PreAboutCount" label="预约人数" align="center" >
                  </el-table-column>
                    <el-table-column  prop="StoresName" label="门店" align="center" >
                    </el-table-column>
                  <el-table-column  prop="state" label="状态" align="center">
                          <template slot-scope="scope">
                            <span class="Info" v-if="scope.row.state == 0">
                              学员取消
                            </span>
                            <span class="coBlue" v-if="scope.row.state == 1">
                              已预约
                            </span>
                            <span class="Success" v-if="scope.row.state == 2">
                              已{{name}}
                            </span>
                            <span class="Danger" v-if="scope.row.state == 3">
                              未到
                            </span>
                            <span class="Info" v-if="scope.row.state == 4">
                              机构取消
                            </span>
                            <span class="Warning" v-if="scope.row.state == 5">
                              请假
                            </span>
                          </template>
                  </el-table-column>
                  </el-table>
                  <Pagination v-bind:child-msg="pageparm" @callFather="callFather11"></Pagination>
            </el-tab-pane>
            <el-tab-pane :label="'直接'+name2+'记录'" name="2" >
              <el-table  :data="hexiaoList" highlight-current-row v-loading="loading" size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
                    <el-table-column  prop="addTime" label="操作日期"  >
          
                    </el-table-column>

                    <el-table-column  prop="Hypeinfo" label="操作内容" align="center" >
                    </el-table-column>
                    <el-table-column  prop="Note" label="备注" align="center" >
                    </el-table-column>

                  <el-table-column  prop="StoresName" label="门店" align="center" >
                    </el-table-column>
              </el-table>
              <Pagination v-bind:child-msg="pageparm" @callFather="callFather11"></Pagination>
            </el-tab-pane>

        </el-tabs>
        <div class="demo-drawer__footer flex-r-x" style="width:50%">
          <el-button size="small" @click="cardMain = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
       
            @click="cardMain = false"
            >确定</el-button
          >
        </div>
    </el-drawer>
    <el-drawer :wrapperClosable= false title="续卡" :visible.sync="xukashow" :direction="direction" size="30%">

      <el-form label-width="140px" :model="ruleForm" :rules="rules" ref="ruleForm" style="padding-bottom:120px">
            <el-form-item label="会员卡：" >
                       <span>{{ruleForm.CardName}}</span>
              </el-form-item>
            <el-form-item label="当前剩余次数：" v-if=" ruleForm.CardType==1 || ruleForm.CardType==2 " >
                       <span>{{vipitem.CardNumber}}次</span>
              </el-form-item>
                    <el-form-item label="购买次数："  v-if=" ruleForm.CardType==1 || ruleForm.CardType==2 " prop="buyCount" >
                        <el-input v-model="ruleForm.CardNumber" placeholder="购买次数" style="width:100px;" size="small"  @input="forceUpdate()"></el-input> 次
                    </el-form-item>
                    <el-form-item label="赠送次数："  v-if=" ruleForm.CardType==1 || ruleForm.CardType==2 " prop="zsCardNumber" >
                        <el-input v-model="ruleForm.zsCardNumber" placeholder="赠送次数" style="width:100px;" size="small"  @input="forceUpdate()"></el-input> 次
                    </el-form-item>
                <el-form-item label="购买后可用次数：" v-if=" ruleForm.CardType==1 || ruleForm.CardType==2 " >
                       <span>{{Number(ruleForm.CardNumber) + Number(vipitem.CardNumber)+ Number(ruleForm.zsCardNumber)}} 次</span>
                </el-form-item>
          
                    <el-form-item label="当前剩余次数：" v-if=" ruleForm.CardType==4 || ruleForm.CardType==5 " >
                       <span>{{vipitem.Amount}}元</span>
              </el-form-item>
                    <el-form-item label="充值金额："  v-if=" ruleForm.CardType==4 || ruleForm.CardType==5 " prop="buyCount" >
                         <span>{{ruleForm.Amount}}元</span>
                      </el-form-item>
                    <el-form-item label="赠送金额："   v-if=" ruleForm.CardType==4 || ruleForm.CardType==5 " prop="zsAmount" >
                        <el-input size="small" v-model="ruleForm.zsAmount" placeholder="赠送金额" style="width:100px;"></el-input> 元
                    </el-form-item>
                    <el-form-item label="期限类型：" v-if="ruleForm.CardType==1 || ruleForm.CardType==3 || ruleForm.CardType==5"  >
                        <span v-if="ruleForm.dayType == 1">{{ruleForm.daysvalue}}日</span>
                         <span v-if="ruleForm.dayType == 2">{{ruleForm.daysvalue}}月</span>
                          <span v-if="ruleForm.dayType == 3">{{ruleForm.daysvalue}}年</span>
                    </el-form-item>
                    <el-form-item  v-if="ruleForm.CardType==1 || ruleForm.CardType==3 || ruleForm.CardType==5" label="赠送期限类别:">
            <el-radio-group v-model="ruleForm.zsdayType" v-on:input="inputSubtotalxk1(ruleForm)">
              <el-radio :label="1">天</el-radio>
              <el-radio :label="2">月</el-radio> 
              <el-radio :label="3">年</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="赠送期限值:"  v-if="ruleForm.CardType==1 || ruleForm.CardType==3 || ruleForm.CardType==5" prop="zsdaysvalue">
              <!-- <el-input-number v-model="ruleForm.zsdaysvalue" :step="1" step-strictly size="small"></el-input-number> -->
              <el-input v-model="ruleForm.zsdaysvalue" v-on:input="inputSubtotalxk1(ruleForm)" placeholder="赠送期限值" style="width:100px;"></el-input> 

              <span style="margin-left:5px" v-if="ruleForm.zsdayType == 1">天</span>
              <span style="margin-left:5px" v-if="ruleForm.zsdayType == 2">月</span>
              <span style="margin-left:5px" v-if="ruleForm.zsdayType == 3">年</span>
        </el-form-item>
                    <el-form-item label="到期时间："  v-if="ruleForm.CardType==1 || ruleForm.CardType==3 || ruleForm.CardType==5" prop="EndTime">
                         <span>{{ruleForm.EndTime}}</span>
                    </el-form-item>
         
     <!-- v-if="showPurchaseAmount " -->
                    <el-form-item size="small" label="应收金额："   prop="YSAmount" >
                        <!-- <el-input v-model="ruleForm.YSAmount"  placeholder="应收金额" style="width:100px;" v-if="isshowGM == 1"   @input="forceUpdate()"></el-input>  -->
                        <!-- v-if="isgoumaijine==1" -->
                        <!-- <span v-if="isshowGM == 0">{{ruleForm.YSAmount}}</span> -->
                         <el-input v-model="ruleForm.YSAmount"  placeholder="应收金额" style="width:100px;"   @input="forceUpdate()"></el-input> 

                        <span>元</span>
                        <!-- <span>{{ruleForm.YSAmount}}元</span> -->
                    </el-form-item>
                    <!-- v-if="showPurchaseAmount" -->
                    <el-form-item size="small" label="实付金额："   prop="PurchaseAmount" >
                        <!-- <el-input v-model="ruleForm.PurchaseAmount" placeholder="实付金额" style="width:100px;"  v-if="isshowGM == 1"  @input="forceUpdate()"></el-input> 
                        <span v-if="isshowGM == 0">{{ruleForm.PurchaseAmount}}</span> -->
                         <el-input v-model="ruleForm.PurchaseAmount" placeholder="实付金额" style="width:100px;"    @input="forceUpdate()"></el-input> 
                        <span>元</span>
                        <!-- <span>{{ruleForm.PurchaseAmount}}元</span> -->
                    </el-form-item>
                    <el-form-item label="续卡时间："  prop="GMtime" >
                        <el-date-picker
                         @input="forceUpdate()"
                            size="small"
                            v-model="ruleForm.GMtime"  
                            align="right"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择售卡时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item  label="业务归属人："  prop="LoginID">
                        <span>{{personName}}</span>
                        <el-button @click="handlePassword1()" type="text">添加</el-button>
                          <el-button v-if="personName!=''"  @click="toDelPer()" icon="el-icon-delete"  type="text" style="margin-left:30px"></el-button>

                    </el-form-item>
                    <el-form-item label="备注：" prop="Note" style="width:90%">
                        <el-input type="textarea" v-model="ruleForm.Note"></el-input>
                    </el-form-item>
      
       
      </el-form>
    
        <div class="demo-drawer__footer flex-r-x" style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
     
            @click="surexu('ruleForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>
    <el-drawer :wrapperClosable= false :title="'编辑'+WZHYName+'信息'" :visible.sync="editFormVisible" :direction="direction" size="30%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" style="padding-bottom:100px">
         <el-form-item label="姓名:" prop="Name">
          <el-input size="small" v-model="editForm.Name" auto-complete="off" placeholder="请输入姓名"  style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="Phone">
          <el-input size="small" v-model="editForm.Phone" auto-complete="off" placeholder="请输入手机号" style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item :label="WZHYName+'编号:'" prop="MemberCard">
          <el-input size="small" v-model="editForm.MemberCard" auto-complete="off" placeholder="请输入编号" style="width: 215px"></el-input>
        </el-form-item>
          <el-form-item :label="WZHYName+'头像:'" prop="HeadUrl">
                <div class="list-img-box cursor">
                  <div v-if="editForm.HeadUrl !== ''">
                    <img
                      :src="editForm.HeadUrl"
                      style="height: 100px;width:100px"
                      alt="图片"
                        @click="uploadPicture('HeadUrl')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('HeadUrl')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                     <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="editForm.HeadUrl"
                  placeholder="请添加头像"
                />
          </el-form-item>
         <el-form-item  v-if="isdengji == 1":label="WZHYName+'等级:'" prop="LevelID">
            <el-select v-model="editForm.LevelID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in typeList1"
                  :key="item.ID"
                  :label="item.LevelName"
                  :value="item.ID">
                </el-option>
              </el-select>
               <!-- <el-button type="text" @click="toSetting">设置</el-button> -->
           </el-form-item>
           <el-form-item label="能力" v-if="isxynl == 1" prop="LevelID">
            <el-select v-model="editForm.CapacityID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in typeListCapacity"
                  :key="item.ID"
                  :label="item.CapacityName"
                  :value="item.ID">
                </el-option>
              </el-select>
              <!-- <el-button type="text" @click="toSetting">设置</el-button> -->
           </el-form-item>
         <el-form-item label="性别:" prop="Sex">
          <el-radio-group v-model="editForm.Sex">
             <el-radio :label="1">男</el-radio>
             <el-radio :label="2">女</el-radio>
           </el-radio-group>
          <!-- <el-input size="small" v-model="editForm.LoginName" auto-complete="off" placeholder="请输入登录账号"></el-input> -->
        </el-form-item>
        <el-form-item label="出生日期:" prop="Birthday" size="small">
          <el-date-picker
            v-model="editForm.Birthday"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="登记日期:" prop="OpenTime" size="small">
          <el-date-picker
            v-model="editForm.OpenTime"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="地址:" prop="Address">
          <el-input size="small" placeholder="请输入地址" v-model="editForm.Address"  auto-complete="off" style="width:90%"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.Note" style="width:90%"></el-input>
        </el-form-item>

      </el-form>
   
        <div class="demo-drawer__footer flex-r-x" style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
     
            @click="submitForm1('editForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>
    <el-dialog
              title="裁切封面"
              :visible.sync="cropperModel"
              width="1200px"
              center
            >
        <cropper-image
                  :Name="cropperName"
                  @uploadImgSuccess="handleUploadSuccess"
                  ref="child"
                  :key="timer"
        >
      </cropper-image> 
    </el-dialog>
            <!--查看大封面-->
    <el-dialog title="查看大封面" :visible.sync="imgVisible" center>
              <img
                :src="imgName"
                v-if="imgVisible"
                style="width: 100%"
                alt="查看"
              />
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="passShow" width="40%" >
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="密码" prop="deptNo">
          <el-input size="small" placeholder="请输入密码" v-model="Pwd" show-password auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="topass()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="储蓄卡扣费" :visible.sync="chongShow" width="40%" >
      <el-form label-width="120px">
        <el-form-item :label="name2+'金额'" prop="money">
          <el-input size="small" placeholder="请输入金额" v-model="money"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="chongShow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="ADDmoney()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="次卡扣次" :visible.sync="chongCi" width="40%" >
      <el-form label-width="120px">
        <el-form-item :label="name2+'次数'" prop="number">
          <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="chongCi = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="ADDCi()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="次卡充值" :visible.sync="chongCi1" width="40%" >
      <el-form label-width="120px">
        <el-form-item label="充值次数" prop="number">
          <el-input size="small" placeholder="请输入充值次数" v-model="number"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="购买金额" prop="GMAmount">
          <el-input size="small" placeholder="请输入金额" v-model="GMAmount"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="购买日期:" prop="GMtime" size="small" v-if="isCard == 0 && title == '添加'">
          <el-date-picker
            v-model="GMtime"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" >
          <el-form-item label="业务归属人" >
         <div class="flexc-cen-x" style="width:100%">
                  <div style="display:flex;flex-wrap:wrap;">
                      <div style="margin-left:5px">{{personName}}                    
                      </div>
                  </div>
                  <div>
                      <el-button bian  @click="handlePassword1()"  type="text" style="margin-right:10px;margin-left:10px">选择</el-button>
                      <el-button bian v-if="personName!=''"  @click="toDelPer()" icon="el-icon-delete"  type="text" style="margin-left:30px"></el-button>
                  </div>
                  
              </div>
            
            
          </el-form-item>
       </el-form>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="chongCi1 = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="ADDCi1()">充值</el-button>
      </div>
    </el-dialog>
    <el-dialog title="储蓄卡充值" :visible.sync="chongShow1" width="40%" >
      <el-form label-width="120px">
        <el-form-item label="充值金额" prop="money">
          <el-input size="small" placeholder="请输入充值金额" v-model="money"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="购买金额" prop="GMAmount">
            <el-input size="small" placeholder="请输入金额" v-model="GMAmount"  auto-complete="off"></el-input>
          </el-form-item>
        <el-form-item label="购买日期:" prop="GMtime" size="small" v-if="isCard == 0 && title == '添加'">
          <el-date-picker
            v-model="GMtime"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" >
          <el-form-item label="业务归属人" >
         <div class="flexc-cen-x" style="width:100%">
                  <div style="display:flex;flex-wrap:wrap;">
                      <div style="margin-left:5px">{{personName}}                    
                      </div>
                  </div>
                  <div>
                      <el-button bian  @click="handlePassword1()"  type="text" style="margin-right:10px;margin-left:10px">选择</el-button>
                      <el-button bian v-if="personName!=''"  @click="toDelPer()" icon="el-icon-delete"  type="text" style="margin-left:30px"></el-button>
                  </div>
                  
              </div>
            
            
          </el-form-item>
       </el-form>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="chongShow1 = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="ADDmoney1()">充值</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改金额" :visible.sync="showDrawerAmount" width="40%"
            >
            <div class="drawerForm">
                <el-form  label-position="right" label-width="120px">
                    
                    <el-form-item label="金额:" prop="Amount" >
                        <el-input v-model="items.Amount" placeholder="请输入金额"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="备注:" prop="Note">
                    <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
                </el-form-item>
                </el-form>
            </div>
             <div slot="footer" class="dialog-footer">
                         <el-button size="small" @click="showDrawerAmount = false">取消</el-button>
                        <el-button type="primary" size="small" @click="submitFormAmountClass()">确认提交</el-button>
                       
                </div>
    </el-dialog>
    <el-dialog :title="cardTitle" :visible.sync="mainShow" width="40%" >
      <el-form label-width="120px" ref="ruleForm" v-if="cardTitle == '停卡'">
         <el-form-item label="会员卡名称："  >
                        <span>{{items.CardName}}</span>
         </el-form-item>
                     <el-form-item   v-if=" items.CardType==1" label="剩余次数："  >
                        <span>{{items.CardNumber}}</span>
                     </el-form-item>
                     <el-form-item label="有效期至："  >
                        <span>{{items.OverdueTime}}</span>
                     </el-form-item>
                     <el-form-item label="剩余天数："  >
                        <span>{{items.CardDays}}天</span>
                     </el-form-item>
                     <el-form-item label="停卡类型："  >
                     <el-radio-group v-model="items.isStopType" >
                                <el-radio label="0">正常停卡</el-radio>
                                <el-radio label="1">固定日期</el-radio>
                             </el-radio-group>
                   </el-form-item>
                   <el-form-item label="请假天数："  v-if="items.isStopType==1" prop="StopDays" >
                        <el-input v-model="items.StopDays" placeholder="天数" style="width:100px;"></el-input> 天
                    </el-form-item>
                    <el-form-item label="停卡开始日期：" prop="StopTime">
                        <el-date-picker
                        size="small"
                            v-model="items.StopTime"
                            align="right"
                              
                            type="date"
                            value-format="yyyy-MM-dd"
                             placeholder="请选择停卡日期">
                        </el-date-picker>
                        <div class="set-police"  >
                         &nbsp;&nbsp;
                         <span style="color: rgb(255, 117, 25);">停卡后,会员卡将暂停使用。解除停卡后启用。</span>
                       </div>
                    </el-form-item>

      </el-form>
      <el-form label-width="140px"  v-if="cardTitle == '解除停卡'">
                    <el-form-item label="会员卡名称："  >
                        <span>{{items.CardName}}</span>
                     </el-form-item>
                     <el-form-item   v-if=" items.CardType==1" label="剩余次数："  >
                        <span>{{items.CardNumber}}</span>
                     </el-form-item>
                     <el-form-item label="停卡日期："  >
                        <span>{{items.StopTime}}</span>
                     </el-form-item>
                     <el-form-item label="停卡天数："  >
                        <span>{{items.stopDays}}天</span>
                     </el-form-item>
                     <el-form-item label="有效期至："  >
                        <span>{{items.OverdueTime}}</span>
                     </el-form-item>
                     <el-form-item label="解除后有效期至："  >
                        <span>{{items.kaiOverdueTime}}</span>
                     </el-form-item>
           
      </el-form>
      <el-form label-width="120px" v-if="cardTitle == '修改次数'">
          <el-form-item label="次数：" prop="CardNumber" >
              <el-input v-model="items.CardNumber"      size="small" placeholder="请输入次数"></el-input>
          </el-form-item>
      </el-form>
      <el-form label-width="120px" v-if="cardTitle == '修改到期时间'">

        <el-form-item label="到期时间：" prop="OverdueTime" >
          <el-date-picker
               size="small"
               v-model="items.OverdueTime"
              align="right"
              type="date"
               value-format="yyyy-MM-dd"
            placeholder="请选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <el-form label-width="120px" v-if="cardTitle == '修改开卡时间'||cardTitle == '开卡'">
        <el-form-item label="开卡日期：" prop="KaiKaTime">
          <el-date-picker
            v-model="items.KaiKaTime"
            align="right"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            @change='selectData3(items)'
            placeholder="请选择开卡日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="有效天数：" v-if=" (items.CardType==1 || items.CardType==3|| items.CardType==5) && items.iskaika == 1 "  prop="CardDays" >
            <el-input v-model="items.CardDays" size="small"  v-on:input="inputSubtotal3(items)" placeholder="有效天数" style="width:100px;"></el-input> 天
        </el-form-item>
   
        <el-form-item label="期限类型：" v-if=" items.iskaika =='0' && (items.CardType==1 || items.CardType==3)">
                        <span v-if="items.dayType == 1">{{items.daysvalue}}日</span>
                         <span v-if="items.dayType == 2">{{items.daysvalue}}月</span>
                          <span v-if="items.dayType == 3">{{items.daysvalue}}年</span>
        </el-form-item>

        <el-form-item label="到期时间："  v-if=" items.CardType==1 || items.CardType==3 || items.CardType==5 " prop="EndTime">
            <span>{{items.OverdueTime}}</span>
        </el-form-item>
      </el-form>
      <el-form label-width="120px" v-if="cardTitle == name2">
          <el-form-item label="扣课课时：" prop="num"  v-if="items.CardType == 1 || items.CardType == 2">
              <el-input v-model="num" placeholder="请输入次数" style="width:215px"></el-input> 次
          </el-form-item>
           <el-form-item label="扣课金额：" prop="num"  v-if="items.CardType == 4 || items.CardType == 5">
              <el-input v-model="singlePrice" placeholder="请输入金额" style="width:215px"></el-input> 元
          </el-form-item>
      </el-form>
      <el-form label-width="120px" v-if="cardTitle == '修改一周预约次数'">
          <el-form-item label="预约次数：" prop="num" >
              <el-input v-model="num"    size="small" placeholder="请输入次数"></el-input> 
          </el-form-item>
      </el-form>
      <el-form label-width="120px">
        <el-form-item label="备注：" prop="Note" style="width:90%">
           <el-input type="textarea" v-model="Note"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog1">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sure()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改折扣" :visible.sync="showZhe" width="40%" >
      <el-form label-width="120px">
          <el-form-item label="折扣："  prop="Amount" >
              <el-input-number v-model="items.Discountcx" :precision="1" :step="0.1" :max="10" :min="0" size="small"></el-input-number> 折 <span style="color:#808080">(0表示无折扣)</span>
          </el-form-item>
        <el-form-item label="备注：" prop="Note" style="width:90%">
           <el-input type="textarea" v-model="Note"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showZhe = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sureZhe()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="操作记录" :visible.sync="jiluShow" width="700px" @click="jiluShow = false">
    <el-table  :data="jiluList" highlight-current-row v-loading="loading" size="small"   element-loading-text="拼命加载中" style="width: 100%;margin-top:-20px">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
        <el-table-column v-if="cardnum == 2"  prop="Amount" label="金额" align="center" >
        </el-table-column>
        <el-table-column v-if="cardnum == 1"  prop="ClassNumber" label="次数" align="center" >
        </el-table-column>
        <el-table-column  v-if="issjjhcf==0"  label="子账号" align="center" >
          <template slot-scope="scope">
            <span v-if="scope.row.MembersSubPhone !=''">
              {{scope.row.MembersSubName}}({{scope.row.MembersSubPhone}})
            </span>
          </template>
        </el-table-column>
        <el-table-column  prop="操作类型" label="操作类型" align="center" >
          <template slot-scope="scope">
            <span v-if="scope.row.Type == 1">充值</span>
            <span v-if="scope.row.Type == 2">消费</span>
            <span v-if="scope.row.Type == 3">禁用</span>
            <span v-if="scope.row.Type == 4">解禁</span>
            <!-- <div class="flex-xy">
              <div style="margin-top:5px;font-size:15px">{{scope.row.Name}}</div>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column  prop="StoresName" label="门店" align="center" >
        </el-table-column>
        <el-table-column  prop="addTime" label="操作时间" align="center" >
        </el-table-column>
        <el-table-column  prop="Note" label="备注" align="center" >
        </el-table-column>
    </el-table>
     <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      
    </el-dialog>
    <el-dialog title="操作记录" :visible.sync="jiluShow1" width="1300px" @click="jiluShow1 = false">
      <el-table  :data="jiluList" size="small" highlight-current-row v-loading="loading"  element-loading-text="拼命加载中" style="width: 100%;margin-top:-20px">
        <!-- <el-table-column align="center" type="selection" width="60">
        </el-table-column> -->
          <el-table-column  prop="Hypeinfo" label="操作详情" align="center" >
          </el-table-column>
          <el-table-column   label="子账号" align="center" v-if="subList.length>0 && issjjhcf==0" >
          <template slot-scope="scope">
            <span v-if="scope.row.MembersSubPhone !=''">{{scope.row.MembersSubName}}({{scope.row.MembersSubPhone}})</span>
          </template>
          </el-table-column>
          <el-table-column  prop="StoresName" label="门店" align="center" >
          </el-table-column>
          <el-table-column  prop="操作类型" label="操作类型" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.Hypetype== 1">充值</span>
              <span v-if="scope.row.Hypetype == 2">修改</span>
              <span v-if="scope.row.Hypetype == 3">{{name2}}</span>
            </template>
          </el-table-column>
          <el-table-column  prop="addTime" label="操作时间" align="center" >
          </el-table-column>

          <el-table-column  prop="Note" label="备注" align="center" >
          </el-table-column>

      </el-table>
     <Pagination v-bind:child-msg="pageparm" @callFather="callFather2"></Pagination>
      
    </el-dialog>
    <el-dialog title="充值记录" :visible.sync="chongji" width="1000px" @click="chongji = false">
      <el-table  :data="jiluList" size="small" highlight-current-row v-loading="loading"  element-loading-text="拼命加载中" style="width: 100%;margin-top:-20px">
        <!-- <el-table-column align="center" type="selection" width="60">
        </el-table-column> -->
          <el-table-column  prop="Amount" label="充值" align="center" >
            <template slot-scope="scope">
              <div v-if="scope.row.Cardtype == 2">{{scope.row.Amount}}元</div>
              <div v-if="scope.row.Cardtype == 1">{{scope.row.ClassNumber}}次</div>
              <!-- <el-button size="small" type="primary"  @click="editYeShow(scope.row)">撤销</el-button> -->
            </template>
          </el-table-column>
         
          <el-table-column  prop="GMAmount" label="购买金额" align="center" >
              <template slot-scope="scope">
              <div >{{scope.row.GMAmount}}元</div>
        
              <!-- <el-button size="small" type="primary"  @click="editYeShow(scope.row)">撤销</el-button> -->
            </template>
          </el-table-column>
          <el-table-column  prop="StoresName" label="门店" align="center" >
          </el-table-column>

          <el-table-column  prop="addTime" label="操作时间" align="center" width="130" >
          </el-table-column>
          <el-table-column  prop="StaffName" label="业务归属人" align="center" >
          </el-table-column>
          <el-table-column  prop="LoginName" label="操作人" align="center" >
          </el-table-column>
          <el-table-column  prop="Note" label="充值备注" align="center" >
          </el-table-column>
          <el-table-column  prop="cxNote" label="撤销备注" align="center" >
          </el-table-column>
          <el-table-column  prop="OrderType" label="操作类型" align="center" >
            <template slot-scope="scope">
              <el-button size="mini" type="info" disabled v-if="scope.row.Iscx == 1"  @click="chexiao(scope.row)">已撤销</el-button>
              <el-button size="mini" type="primary" v-if="scope.row.Iscx != 1"  @click="chexiao(scope.row)">撤销</el-button>
            </template>
          </el-table-column>
      </el-table>
     <Pagination v-bind:child-msg="pageparm" @callFather="callFather3"></Pagination>
      
    </el-dialog>
    <el-dialog title="订单记录" :visible.sync="yeShow" width="1300px" @click="yeShow = false">
      <el-table  :data="jiluList" size="small" highlight-current-row v-loading="loading"  element-loading-text="拼命加载中" style="width: 100%;margin-top:-20px">
        <!-- <el-table-column align="center" type="selection" width="60">
        </el-table-column> -->
          <el-table-column  prop="OrderType" label="操作类型" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.OrderType== 1">发卡</span>
              <span v-if="scope.row.OrderType == 2">续卡</span>
            </template>
          </el-table-column>
          <el-table-column  prop="StaffName" label="充值" align="center" >
            <template slot-scope="scope">
               <span v-if="scope.row.CardType == 1">
                 {{scope.row.CardNumber}}次
                    <span v-if="scope.row.dayType == 1">
                      ({{scope.row.daysvalue}}日)
                   </span>
                    <span v-if="scope.row.dayType == 2">
                      ({{scope.row.daysvalue}}月)
                   </span>
                    <span v-if="scope.row.dayType == 3">
                      ({{scope.row.daysvalue}}年)
                   </span>
               </span>
                <span v-if="scope.row.CardType == 2">{{scope.row.CardNumber}}次</span>
                <span v-if="scope.row.CardType == 3">
                   <span v-if="scope.row.dayType == 1">
                      {{scope.row.daysvalue}}日
                   </span>
                    <span v-if="scope.row.dayType == 2">
                      {{scope.row.daysvalue}}月
                   </span>
                    <span v-if="scope.row.dayType == 3">
                      {{scope.row.daysvalue}}年
                   </span>
                </span>
                <span v-if="scope.row.CardType == 4">{{scope.row.Amount}}元</span>
                <span v-if="scope.row.CardType == 5">
                  {{scope.row.Amount}}元
                    <span v-if="scope.row.dayType == 1">
                      ({{scope.row.daysvalue}}日) 
                   </span>
                    <span v-if="scope.row.dayType == 2">
                      ({{scope.row.daysvalue}}月)
                   </span>
                    <span v-if="scope.row.dayType == 3">
                      ({{scope.row.daysvalue}}年)
                   </span>
                </span>
            </template>
          </el-table-column>
          <el-table-column  prop="StaffName" label="赠送" align="center" >
            <template slot-scope="scope">
               <span v-if="scope.row.CardType == 1">
                 {{scope.row.zsCardNumber}}次
                    <span v-if="scope.row.zsdayType == 1">
                      ({{scope.row.zsdaysvalue}}日)
                   </span>
                    <span v-if="scope.row.zsdayType == 2">
                      ({{scope.row.zsdaysvalue}}月)
                   </span>
                    <span v-if="scope.row.zsdayType == 3">
                      ({{scope.row.zsdaysvalue}}年)
                   </span>
               </span>
                <span v-if="scope.row.CardType == 2">{{scope.row.zsCardNumber}}次</span>
                <span v-if="scope.row.CardType == 3">
                   <span v-if="scope.row.zsdayType == 1">
                      {{scope.row.zsdaysvalue}}日
                   </span>
                    <span v-if="scope.row.zsdayType == 2">
                      {{scope.row.zsdaysvalue}}月
                   </span>
                    <span v-if="scope.row.zsdayType == 3">
                      {{scope.row.zsdaysvalue}}年
                   </span>
                </span>
                <span v-if="scope.row.CardType == 4">{{scope.row.zsAmount}}元</span>
                <span v-if="scope.row.CardType == 5">
                  {{scope.row.zsAmount}}元
                    <span v-if="scope.row.zsdayType == 1">
                      ({{scope.row.zsdaysvalue}}日) 
                   </span>
                    <span v-if="scope.row.zsdayType == 2">
                      ({{scope.row.zsdaysvalue}}月)
                   </span>
                    <span v-if="scope.row.zsdayType == 3">
                      ({{scope.row.zsdaysvalue}}年)
                   </span>
                </span>
            </template>
          </el-table-column>
          <el-table-column  prop="StaffName" label="业务归属人" align="center" >
          </el-table-column>
          <el-table-column  prop="PurchaseAmount" label="购买金额" align="center" >
          </el-table-column>
          <el-table-column  prop="GMtime" label="购买时间" align="center" >
          </el-table-column>
          <el-table-column  prop="addTime" label="操作时间" align="center" >
          </el-table-column>
          <el-table-column  prop="OrderType" label="操作" align="center" >
            <template slot-scope="scope">
              <el-button size="small" type="primary"  @click="editYeShow(scope.row)">修改业务归属人</el-button>
            </template>
          </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="修改业务归属人" :visible.sync="editYe" width="500px" @click="editYe = false">
      <el-form>
        <el-form-item  label="业务归属人：" prop="LoginID">
          <span>{{editRow.StaffName}}</span>
            <el-button @click="handlePassword1()" style="margin-left:10px" type="text">修改</el-button>   
        </el-form-item>
      </el-form>
       <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editYe = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sureYe()">修改</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="subTitle" :visible.sync="editSub" width="40%" >
      <el-form label-width="120px" :model="form" :rules="rules1" ref="form">
        <el-form-item label="姓名" prop="Name">
          <el-input size="small" placeholder="请输入姓名" v-model="form.Name"  auto-complete="off"></el-input>
        </el-form-item>
                <el-form-item label="电话" prop="Phone">
          <el-input size="small" placeholder="请输入电话" type="number" v-model="form.Phone"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="form.Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editSub = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sureSub('form')">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'选择'+WZYGName" :visible.sync="personShow" width="500px" @click="passShow = false">
        <div class="dialogMain" style="width:100%;height:400px">
            <el-collapse accordion  >
                <el-collapse-item v-for="(items) in personList" :key="items.ID" >
                    <template slot="title">
                            <!-- <img src="../../assets/icon/choose.png" alt="" style="width:18px;height:18px">   -->
                            <span style="margin-left:5px">{{items.Name}}</span>
                    </template>
                    <div class="cursor" v-for="item in items.listsub" :key="item.ID" style="margin-left:20px" @click="choose(item)" >
                        <div class="flex-spc-x" style="margin-top:5px" > 
                            
                            <div style="margin-left:5px;font-size:15px">
                                {{item.Name}}
                            </div>
                            <el-button type="text">选择</el-button>
                        </div> 
                        
                    </div>
                </el-collapse-item>

            </el-collapse>

        </div>
    </el-dialog>
    <el-dialog title="撤销充值" :visible.sync="cheshow" width="40%" >
      <el-form label-width="120px" >
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cheshow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sureChe()">撤销</el-button>
      </div>
    </el-dialog>
    <el-dialog title="兑换积分" :visible.sync="duishow" width="40%" >
      <el-form label-width="120px" >
        <el-form-item label="积分:" prop="Note">
              <el-input v-model="info" placeholder="请输入积分"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="duishow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sureDui()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="赠送积分" :visible.sync="zengshow" width="40%" >
      <el-form label-width="120px" >
        <el-form-item label="积分:" prop="Note">
              <el-input v-model="info" placeholder="请输入积分"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="zengshow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sureZeng()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="赠送优惠券" :visible.sync="Tcshow" width="40%" >
      <el-form label-width="120px" >
        <el-form-item label="优惠券:" prop="Note">
          <div class="flexc-cen-x">
            <el-input placeholder="选择优惠券" size="small" :disabled="true" v-model="yhqItems.Title" style="width:200px" ></el-input>
              <el-button style="margin-left:10px" type="primary" size="mini" @click="chooseYhq">选择优惠券</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="Tcshow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sureYhq()">确定</el-button>
      </div>
    </el-dialog>
   <el-dialog title="选择优惠券" :visible.sync="chooseYhqshow" width="1000px" @click="chooseYhqshow = false">
      <el-table  :data="allTcList" size="small" highlight-current-row v-loading="loading"  element-loading-text="拼命加载中" style="width: 100%;margin-top:-20px">
        <el-table-column  prop="Title" label="优惠券名称">
        </el-table-column>
        <el-table-column  prop="DDPrice" label="订单价格" align="center" >
        </el-table-column>
        <el-table-column  prop="preferentialType" label="优惠类别" align="center" >
          <template slot-scope="scope">
            <div class="flex-xy">
              <div v-if="scope.row.preferentialType == 2 " style="margin-top:5px;">减免</div>
              <div v-if="scope.row.preferentialType == 1 " style="margin-top:5px;">打折</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column  prop="addTime" label="优惠" align="center" >
          <template slot-scope="scope">
            <div class="flex-xy">
              <div v-if="scope.row.preferentialType == 2 " style="margin-top:5px;">{{scope.row.preferentialvalue}}元</div>
              <div v-if="scope.row.preferentialType == 1 " style="margin-top:5px;">{{scope.row.preferentialvalue*10}}折</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column  prop="addtime" label="开始时间" >
        </el-table-column>
        <el-table-column  prop="endTime" label="结束时间" >
        </el-table-column>
          <el-table-column  prop="操作类型" label="操作类型" align="center" >
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="sureAllTc(scope.row)">选择</el-button>
            </template>
          </el-table-column>
       

      </el-table>
      <Pagination v-bind:child-msg="pageparm4" @callFather="callFatherYhq"></Pagination>
      
    </el-dialog>
    <!-- 发卡优惠券 -->
    <el-dialog title="选择优惠券" :visible.sync="chooseMyShow" width="1000px" @click="chooseMyShow = false">
      <el-table  :data="myyhqList" size="small" highlight-current-row v-loading="loading"  element-loading-text="拼命加载中" style="width: 100%;margin-top:-20px">
        <el-table-column  prop="Title" label="优惠券名称">
          <template slot-scope="scope">
            <div>
               <div>{{scope.row.CouponActivityinfo.Title}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column  prop="" label="订单价格" align="center" >
          <template slot-scope="scope">
            <div class="flex-xy">
               <div>{{scope.row.CouponActivityinfo.DDPrice}}元</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column  prop="preferentialType" label="优惠类别" align="center" >
          <template slot-scope="scope">
            <div class="flex-xy">
              <div v-if="scope.row.CouponActivityinfo.preferentialType == 2 " style="margin-top:5px;">减免</div>
              <div v-if="scope.row.CouponActivityinfo.preferentialType == 1 " style="margin-top:5px;">打折</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column  prop="addTime" label="优惠" align="center" >
          <template slot-scope="scope">
            <div class="flex-xy">
              <div v-if="scope.row.CouponActivityinfo.preferentialType == 2 " style="margin-top:5px;">{{scope.row.CouponActivityinfo.preferentialvalue}}元</div>
              <div v-if="scope.row.CouponActivityinfo.preferentialType == 1 " style="margin-top:5px;">{{scope.row.CouponActivityinfo.preferentialvalue*10}}折</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column  prop="DueToTime" label="到期时间" >
        </el-table-column>
        <el-table-column  prop="操作类型" label="操作类型" align="center" >
            <template slot-scope="scope">
              <el-button v-if="scope.row.issy == 1" size="small" type="primary" @click="sureMyYhq(scope.row)">选择</el-button>
              <el-button disabled v-if="scope.row.issy != 1" size="small" type="primary" >选择</el-button>
            </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="yyJYtitle" :visible.sync="yyZYShow" width="40%" >
        <el-form>
                    <el-form-item label="不可预约周期：" prop="Cycle"  >
                        <el-checkbox-group v-model="checkedCycles" @change="handleChange">
                            <el-checkbox v-for="item in CycleList" :label="item.Id" :key="item.index" name="Cycle">
                                {{item.Label}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="yyZYShow = false">取消</el-button>
            <el-button size="small" type="primary"   @click="submityyJYForm()">确认</el-button>
        </div>  
      </el-dialog>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";

import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
        yhq:'1',
        jifenList:[],
        isEdit:false, 
        cardMain:false,
        allTcList:[],
        typeName:'1',
        myyhq:{
          CouponActivityinfo:{

          }
        },
        yhqType:[
          {
            ID:'1',
              name: '未使用',
          },
           {
            ID:'2',
              name: '已使用',
          },
           {
            ID:'3',
            name: '已过期',
          },
           {
            ID:'4',
            name: '已作废',
          },
        ],
        jfList:[
          {
            ID:'1',
            name: '赠送积分',
          },
          {
            ID:'2',
              name:'兑换积分'
          }
         
  
        ],
        jiluShow1:false,
        mainShow:false,
        iscxjk:localStorage.getItem('iscxjk'),
        iscdyy:localStorage.getItem('iscdyy'),
        typeList1:[],
        cardTitle:'',
        personName:'',
        SelectStoresID :'',
        singlePrice:'',
        activeName1:0,
        isweekdays:localStorage.getItem('isweekdays'),
        IsCD:localStorage.getItem("IsCD"),
        WZCDName:localStorage.getItem('WZCDName'),
        num:1,
        yeShow:false,
        subList:[],
        preList:[],
        orderList:[],
        PreZJList:[],
        hexiaoList:[],
        cheshow:false,
        form:{
          Note:'',
          Name:'',
          Phone:'',
        },
         rules1: {
          Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
      },
      zhekou:'',
        ruleForm:{
                    StoresID: "",
                    OpenTime:"",
                    Birthday:"",
                    Address: "",
                    Note: "",
                    isSource:"1",
                    Sex: "1",
                    Isbangka: "1",
                    CardNum:"",
                    CardNumber:"",
                    CardDays:"",
                    Amount:"",
                    CardID:"",
                    CardName:"",
                    CardType:"",
                    PurchaseAmount:"",
                    iskaika:"1",
                    isyhq:'0',
                    KaiKaTime:"",
                    EndTime:"",
                    isjiebang:0,
                    isaddzi:0,
                    iscz:0,
                    LoginID:"",
                    buyCount:"" ,
                    YSAmount:"" ,
                    GMtime:"" ,
                    daysvalue:"" ,
                    dayType:"" ,
                    zsCardNumber:"0" ,
                    zsdaysvalue:"0" ,
                    zsdayType:1,
                    zsAmount:"0" ,
      },
        showDrawer:false,
                showDrawerfaka:false,
                showRightDrawer:false,
                showDrawerClass:false,
                showKynumber: false,
                showyxdays: false,
                showAmount: false,
                showPurchaseAmount: false,
                showCardNum: false,
                showDrawerNote: false,
                showDrawerCardNum: false,
                showDrawerCardNumber: false,
                showDrawerCardDays: false,
                showDrawerAmount: false,
                showDrawerAdminHype: false,
                showDrawerMJFAdminHype: false,
                showCardID: true,
      // cardShow:false,
      cardShow:false,
      khIson:0,
      activeName:"0",
      isshowGM:'',
      imgVisible:false,
      cropperModel:false,
      CardID:'',
      direction: "ltr",
      passShow:false,
      typeList:[],
      TeacherList:[],
      list:[],
      money:'',
      number:'',
      ispaiban: localStorage.getItem('ispaiban'),
      iszjyy: localStorage.getItem('iszjyy'),
      chongCi:false,
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      jiluShow:false,
      chongShow:false,
      title: '添加',
      timer:'',
      cropperName:'',
      tableData:[],
      Pwd:'',
      id:'',
      editShow:false,
      items:{},
      vipitem:{},
      isCard:localStorage.getItem('isCard'),
      personList:[],
      cardList:[],
      nmae1:'',
      yhqList:[],
      editForm: {
        LoginName:"",
        Phone:"",
        Name:"",
        pwd:"",
        money:"",
        ShopName:"",
        HeadUrl:'',
        Sex:1,
        Address:'',
        Birthday:'2000-10-10',
        OpenTime:'',
        LevelID:'',
        StaffID:'',
 
      },
      subTitle:'',
      editSub:false,
      jiluList:[],
      Note:'',
      xukashow:false,
      xuEndTime:'',
      chongShow1:false,
      chongCi1:false,
      cardnum:'',
      Limits:[],
      personShow:false,
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      q7:false,
      q8:false,
      w1:false,
      w2:false,
      w3:false,
      w4:false,
      w5:false,
      w6:false,
      w7:false,
      w8:false,
      w9:false,
      w10:false,
      w11:false,
      w12:false,
      q10:false,
      q11:false,
      isCashier: localStorage.getItem('isCashier'),
      editRow:{},
      // rules表单验证
      rules: {
        MemberCard:[{ required: true, message: '请输入会员编号', trigger: 'blur' }],
        CardID: [{ required: true, message: '请选择会员卡', trigger: 'blur' }],
        Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
        ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
        GMtime:[{required: true, message: '请选择售卡时间', trigger: 'blur'}]
      },
      name2:'',
      editYe:false,
      formInline4:{
        page: 1,
        limit: 10,
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      typeListCapacity:[],
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
    WZCDName:localStorage.getItem('WZCDName'),
    name:'',
    showZhe:false,
    personName:"",
    StaffID:'',
    GMAmount:'',
    GMtime:'',
    rowID:'',
    zengshow:false,
    duishow:false,
    chongji:false,
    info:'',
    Tcshow:false,
    chooseYhqshow:false,
    yhqItems:{},
    yhmoney:'',
    myyhqList:[],
    isjifen:localStorage.getItem('isjifen'),
    isyhq:localStorage.getItem('isyhq'),
    isdengji:localStorage.getItem('isdengji'),
    issjjhcf:localStorage.getItem("issjjhcf"),
    isxynl:localStorage.getItem("isxynl"),
    chooseMyShow:false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      pageparm4: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      CycleList:[
                {Id:"1",Label:"周一"},
                    {Id:"2",Label:"周二"},
                    {Id:"3",Label:"周三"},
                    {Id:"4",Label:"周四"},
                    {Id:"5",Label:"周五"},
                    {Id:"6",Label:"周六"},
                    {Id:"7",Label:"周日"}
                ],
                checkedCycles:[],
                yyJYtitle:"",
                yyZYShow:false,
                JYCycle:"",
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.isshowGM = localStorage.getItem("isshowGM")
    this.SelectStoresID =  localStorage.getItem('SelectStoresID')
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.WZCDName = localStorage.getItem('WZCDName')
     if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 = true
          this.q7 = true
          this.q8 = true
          this.w1 = true
          this.w2 = true
          this.w3 = true
          this.w4 = true
          this.w5 = true
          this.w6 = true
          this.w7 = true
          this.w8 = true
          this.w9 = true
          this.w10 = true
          this.w11 = true
          this.w12 = true
          this.q10 = true
          this.q11 = true
      }
     this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
          if(items == 822){
            this.q1 = true
          }
          if(items == 823){
            this.q2 = true
          }
          if(items == 824){
            this.q3 = true
          }
          if(items == 825){
            this.q4 = true
          }
          if(items == 826){
            this.q5 = true
          }
          if(items == 827){
            this.q6 = true
          }
          if(items == 828){
            this.q7 = true
          }
          if(items == 829){
            this.q8 = true
          }
          if(items == 8251)
           this.q10 = true
          if(items == 8223)
          this.q11 = true
          if(items == 8211){
            this.w1 = true
          }
          if(items == 8212){
            this.w2 = true
          }
          if(items == 8213){
            this.w3 = true
          }
          if(items == 8214){
            this.w4 = true
          }
          if(items == 8215){
            this.w5 = true
          }
          if(items == 8216){
            this.w6 = true
          }
          if(items == 8217){
            this.w7 = true
          }
          if(items == 8218){
            this.w8 = true
          }
          if(items == 8219){
            this.w9 = true
          }
          if(items == 8220){
            this.w10 = true
          }
          if(items == 8221){
            this.w11 = true
          } 
          if(items == 816){
            this.w12 = true
          }
          
   })

      if(this.isCard == 0 ){
        if(this.iszjyy == 1){
           this.activeName = '1'
        }else if(this.ispaiban == 1){
              this.activeName = '2'
        }
    

      }

      if(localStorage.getItem('StoresType') == 1){
          this.name = '签到'
          this.nmae1 = '直接'
          this.name2 = '消课'
      }  else {
          this.name = '核销'
          this.nmae1 = localStorage.getItem('zzjy') 
          this.name2 = '消费'
      }     
         
      this.getList()
      this.getListMembersvip()
      this.getType()
      this.getTeachList()
      this.getType1()
      this.getSubList()
      this.getList1()
      this.getListMembersPayOrder()
      this.getListMembersPreAboutZJ()
      this.getListMembersPreAbout()
      this.gettypeListCapacity()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    sureMyYhq(row){
      this.myyhq = row
      if(this.myyhq.CouponActivityinfo.preferentialType ==1 ){
          this.yhmoney = this.ruleForm.PurchaseAmount* row.CouponActivityinfo.preferentialvalue
      } 
      if(this.myyhq.CouponActivityinfo.preferentialType == 2 ){
        this.yhmoney = this.ruleForm.PurchaseAmount - row.CouponActivityinfo.preferentialvalue
      } 
      this.chooseMyShow = false
    },
    chooseMyYhq(){
        this.getMyhyq()
        this.chooseMyShow = true

        
    },gettypeListCapacity(){
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
      
      }
   
        var that = this
      this.ajax('getListMembersCapacity.aspx ',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                 that.typeListCapacity = res.data
           } 

      })

    },
      handlejie(row){
        this.$confirm("确定要作废吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          CouponMemberID:row.ID,
          state:4
        }
        var that = this
        this.ajax('editCouponMemberstate.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "作废成功",duration:2000,
              });
                that.formInline.page = 1
                that.getTc()
              //  that.provinceList = res.data
            }

        })
        })
       
      },
      sureYhq(){
      var data = { 
              MembersID:this.$route.params.id,
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              CouponID:this.yhqItems.ID,
              LoginID:localStorage.getItem("LoginID"),
          }
          var that = this
          this.ajax('addCouponMember.aspx',JSON.stringify(data),"POST",function(res){

            if (res.orsuccess == "1") {
              that.$message({
                  type: "success",
                  message: "赠送成功",duration:2000,
                });
                that.Tcshow = false
                that.formInline.page = 1
                  that.getTc()
              }

          })
      },
      sureAllTc(row){
        this.yhqItems  = row
        this.chooseYhqshow = false
      },
      getjifen(){
        var data = { 
          SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            MembersID:this.$route.params.id,
            Type:this.typeName,
            pages:this.formInline.page,
            psize:this.formInline.limit
          }
          var that = this
        this.ajax('getListIntegralInfo.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
                  res.data.forEach(items => {
                  items.addtime = items.addtime.replace(/\//g, '-')
                });
                that.jifenList = res.data   
                that.pageparm.total = res.allcount
              }
        })
      },
      changeType(){
        this.formInline.page = 1
        this.getjifen()
      },
      chooseYhq(){
        this.chooseYhqshow = true
      },
      changeyhqType(){
    
        this.formInline.page = 1
        this.getTc()
      },
      tozengTc(){
        this.yhqItems = {}
        this.getAllTc()
      
      },
      getAllTc(){
       var data = { 
            MembersID:this.$route.params.id,
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            pages:this.formInline4.page,
            psize:this.formInline4.limit,
            LoginID:localStorage.getItem("LoginID"),
        }
        var that = this
        this.ajax('getListCouponActivityff.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.allTcList = res.data
              that.Tcshow = true
              that.pageparm4.total = res.allcount
            }

        })
    },
   getTc(){
       var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.$route.params.id,
          AcTimeState:this.yhq,
          pages:this.formInline.page,
          psize:this.formInline.limit
        }
        var that = this
       this.ajax('getListCouponMember.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              //   res.data.forEach(items => {
              //    items.addtime = items.addtime.replace(/\//g, '-')
              //  });
              that.yhqList = res.data   
               that.yhqList.forEach(items => {
                   items.CouponActivityinfo.startTime = items.CouponActivityinfo.startTime.replace(/\//g, '-')
                   items.CouponActivityinfo.endTime = items.CouponActivityinfo.endTime.replace(/\//g, '-')
                });
              that.pageparm.total = res.allcount
            }
      })
   },
    sureDui(){
        var data = { 
            MembersID:this.$route.params.id,
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            Integral:this.info,
            Note:this.Note,
            LoginID:localStorage.getItem("LoginID"),
        }
        var that = this
        this.ajax('DHIntegralInfo.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "兑换成功",duration:2000,
              });
                 that.formInline.page = 1
            that.getjifen()
              that.getList()
            that.duishow = false
              //  that.provinceList = res.data
            }

        })

    },
    sureZeng(){
        var data = { 
            MembersID:this.$route.params.id,
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            Integral:this.info,
            Note:this.Note,
            LoginID:localStorage.getItem("LoginID"),
        }
        var that = this
        this.ajax('addIntegralInfo.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "赠送成功",duration:2000,
              });
             that.formInline.page = 1
              that.getjifen()
              that.getList()
              that.zengshow = false
            
              //  that.provinceList = res.data
            }

        })

    },
    tozeng(){
    
      this.info = 0
      this.Note = ''
      this.zengshow = true
 
    },


    todui(){
      this.info = 0
      this.Note = ''
      this.duishow = true
    },
    chexiao(row){
      this.Note = ''
      this.cheshow = true
      this.rowID = row.ID

    },
    sureChe(){
      var data = { 

          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersID:this.$route.params.id,
          LoginID:localStorage.getItem("LoginID"),
          cxNote:this.Note,
          XKDetailYJGSID:this.rowID
        }
        var that = this
        this.ajax('setXKDetailYJGSCX.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "撤销成功",duration:2000,
              });
              that.cheshow = false
              that.getCi()
              that.getList()
              // that.editYe = false
              //  that.provinceList = res.data
            }

        })
    },
    sureYe(){
      var data = { 

          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          OrderID:this.editRow.ID,
          LoginID:this.editRow.LoginID,
        }
        var that = this
        this.ajax('editOrderLoginID.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
              that.getYeList()
              that.editYe = false
              //  that.provinceList = res.data
            }

        })
    },
    editYeShow(row){
      this.editRow =row
      this.editYe = true
    },
      sureZhe(){
         var data = { 

          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:this.items.ID,
          Note:this.Note,
          Discountcx:this.items.Discountcx,
          sourceID:localStorage.getItem("LoginID"),
          sourceName:localStorage.getItem("Name")  

        }
        var that = this
        this.ajax('editMembersvipDiscountcx.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
              that.showZhe = false
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              //  that.provinceList = res.data
            }

        })
    },
    editzhe(items){
      this.items = items
      this.showZhe = true
    },
    choose(items){
      if(this.editYe == true){

        this.editRow.StaffName = items.Name
        this.editRow.LoginID =  items.ID
      }
          this.personName = items.Name
          this.StaffID = items.ID
          this.personShow = false
          this.ruleForm.LoginID = items.ID
      },
    toDelPer(){
        this.editForm.LoginID =''
        this.personName = ''
        this.StaffID = ''
   },

    handlePassword1(){

        this.personShow = true

    },
    toSetting(){
      this.$router.push({
        path:`/vip/vipLevel`
      })
    },
    getListMembersPayOrder(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.$route.params.id,
          pages:this.formInline.page,
          psize:this.formInline.limit
          }
          var that = this
          this.ajax('getListMembersPayOrder.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that. orderList =res.data     
               that.orderList.forEach(items => {
                 items.addTime = items.addTime.replace(/\//g, '-')
               });
               that.pageparm.total = res.allcount
        }
      })
    },
    getListMembersPreAboutZJ(){
       var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.$route.params.id,
          pages:this.formInline.page,
          psize:this.formInline.limit
        }
        var that = this
       this.ajax('getListMembersPreAboutZJ.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.PreZJList =res.data      
             that.pageparm.total = res.allcount
            }
      })
    },
    getListMembersPreAbout(){
        var data = { 
            SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            MembersID:this.$route.params.id,
            pages:this.formInline.page,
            psize:this.formInline.limit
          }
          var that = this
       this.ajax('getListMembersPreAbout.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              that.preList = res.data     
              that.preList.forEach(items => {
                  items.SKtime = items.SKtime.replace(/\//g, '-')
              }); 
              that.pageparm.total = res.allcount
            }
      })
    },


    sureSub(editData){
      this.$refs[editData].validate(valid => {
        if (valid) {
            if(this.subTitle == '添加子账号'){

                var data = this.form
                data.MembersID = this.$route.params.id,
                data.SelectStoresID  = this.SelectStoresID 
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                var that = this
                 this.ajax('addMembersSub.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                            that.$message({
                            type: "success",
                            message: "添加成功",duration:2000,
                          });
                        that.editSub = false
                        that.getSubList()
                        // that.get()
                      }

                  })
            } else {
                 var data = this.form
                data.MembersSubID = this.form.ID
                data.SelectStoresID  = this.SelectStoresID 
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                var that = this
                 this.ajax('editMembersSub.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                            that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                          });
                        that.editSub = false
                        that.getSubList()
                        // that.get()
                      }

                  })
            }
          } 
        })
    },
    editZi(row){
        if(row){
          this.form = row;
           if(this.form.LevelID == 0){
            this.form.LevelID = ''
          }
        this.subTitle = '修改子账号'
        } else {
          this.subTitle = '添加子账号'
        }
        this.editSub = true
    },
    deleteSub(row){
    
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
            MembersSubID:row.ID,
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token")
        }
        var that = this
        this.ajax('delMembersSub.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
            that.getSubList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
    },
    getSubList(){
       var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.$route.params.id,
          }
          var that = this
       this.ajax('getListMembersSub.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.subList =res.data      
            }
      })
     
    },
    tojilu(num){
      if(num){
         this.cardnum  = num
      }
     
      var data = { 
          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersID:this.list.ID,
          Cardtype:this.cardnum,
          pages:this.formInline.page,
          psize:this.formInline.limit

        }
        var that = this
        this.ajax('getListXKDetail.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.jiluList =  res.data
              that.jiluList.forEach(items => {
                  items.addTime = items.addTime.replace(/\//g, '-')
              });
              that.jiluShow = true
             that.pageparm.total = res.allcount
              //  that.provinceList = res.data
            }

        })
    },
    tochongji(){
      this.formInline.page = 1
      this.getCi()
    },
  getCi(){
     var data = { 
          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersID:this.list.ID,
          Cardtype:this.cardnum,
          pages:this.formInline.page,
          psize:this.formInline.limit
        }
        var that = this
        this.ajax('getListXKDetailYJGS.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.jiluList =  res.data
              that.jiluList.forEach(items => {
                  items.addTime = items.addTime.replace(/\//g, '-')
              });
              that.chongji = true
             that.pageparm.total = res.allcount
              //  that.provinceList = res.data
            }

        })
  },
    getYeList(items){
      if(items){
              this.items = items
          }
    
       var data = { 
          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:this.items.ID,
          MembersID:this.$route.params.id,


        }
        var that = this
        this.ajax('getListMembersvipIDYJ.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
         
              that.jiluList =  res.data
              that.jiluList.forEach(items => {
                items.addTime = items.addTime.replace(/\//g, '-')
              });
             

              that.yeShow = true
            }

        })
    },
    giveCardList(items){
      if(items){
          this.items = items
      }
     

       var data = { 
          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:this.items.ID,
          pages:this.formInline.page,
          psize:this.formInline.limit


        }
        var that = this
        this.ajax('getListAdminHype.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
             that.jiluShow1 = true
              that.jiluList =  res.data
              that.jiluList.forEach(items => {
                items.addTime = items.addTime.replace(/\//g, '-')
              });
             
              that.pageparm.total = res.allcount
  
            }

        })
    },
    closeCard(num){
         this.$confirm("确定禁用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersID:this.list.ID,
          Isdisable:num
        }
        var that = this
        this.ajax('editMemberscxIsdisable.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "禁用成功",duration:2000,
              });
            that.getList()
           
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
         
        });
   


      },
    sureCard(num){
      this.$confirm("确定要启用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersID:this.list.ID,
          Isdisable:num
        }
        var that = this
        this.ajax('editMembersckIsdisable.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "启用成功",duration:2000,
              });
     that.getList()
           
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
          
        });
   

      },
    getType1(){
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
      }
      var that = this
      this.ajax('getListMembersLevel.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
  
                that.typeList1 = res.data
                //  loading.close();
          } 
       })
    
    },
    surexu(){
       var data = this.ruleForm
            data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")
            data.sourceID = localStorage.getItem("LoginID")  
            data.sourceName = localStorage.getItem("Name")   
            data.MembersID = this.$route.params.id
            data.MembersvipID = this.CardID
       
        
            data.SelectStoresID  = this.SelectStoresID  
            var that = this
              this.ajax('addMembersvipXK.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                    that.personName = ''
                            that.$message({
                            type: "success",
                            message: "续卡成功",duration:2000,
                          });
                        that.getCardMain()
                        that.closeDialog()
                        that.getList()
                        that.getListMembersvip()
                        // this.getType()
                        //   this.getTeachList()
                      }

                  })

              
    },
    delPerson(){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersID:this.list.ID,
        
        }
        var that = this
        this.ajax('delMembers.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });

              that.$router.push({ path: '/vip/vip'})
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
    selectData3(val){
        console.log(val)
        if(val.iskaika == '1'){
          if(val.CardType==1 || val.CardType==3|| val.CardType==5){
                    var date = new Date(val.KaiKaTime);//比如sourceDate传参“2019-03-31”
                    var buycount = parseInt(val.CardDays);
                    date.setDate(date.getDate() + buycount);
                    var year=date.getFullYear();
	     	        var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
	    	        var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();

                    val.OverdueTime = year+"-"+month+"-"+day;
                }
        } else {
 if(val.CardType==1 || val.CardType==3 || val.CardType==5){
                    var date = new Date(val.KaiKaTime);//比如sourceDate传参“2019-03-31”)
                    // console.log(val.CardDays)
                    if(val.dayType == 1){
                      var buycount = parseInt(val.daysvalue);
                      date.setDate(date.getDate() + buycount - 1);
                      var year=date.getFullYear();
                      var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                      var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                      val.OverdueTime = year+"-"+month+"-"+day;
                    }
                     if(val.dayType == 2){
                     var buycount = parseInt(val.daysvalue);
                      // date.setDate(date.getDate() + 0);
                      date.setMonth(date.getMonth()+ buycount);
                      date.setDate(date.getDate()  - 1);
                      var year=date.getFullYear();
                      var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                      var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                      val.OverdueTime = year+"-"+month+"-"+day;
                    }
                     if(val.dayType == 3){
                      var buycount = parseInt(val.daysvalue);
                      date.setDate(date.getDate() -1);
                      var year=date.getFullYear() + buycount;
                      var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                      var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                      val.OverdueTime = year+"-"+month+"-"+day;
                    }
                    // var buycount = parseInt(val.CardDays);
                 
                }
        }

     
    },
    inputSubtotal3(val){

                    if(val !=''){
                           if(val.CardType==1 || val.CardType==3|| val.CardType==5){
                    var date = new Date(val.KaiKaTime);//比如sourceDate传参“2019-03-31”
                     var buycount = parseInt(val.CardDays);

                     date.setDate(date.getDate() + buycount);
                    var year=date.getFullYear();
	     	        var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
	    	        var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                    val.OverdueTime = year+"-"+month+"-"+day;
                    }
                    }
              
    },

    xukaClick(it){
      this.CardID = it.ID
      var data = { SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            CardID:it.CardID
            // pages:this.formInline.page,
            // psize:this.formInline.limit,
            // selectName:'',
            // ProjectTypeID:this.active
            // StaffTypeID:this.active
        }
        
        var that = this
        this.ajax('getMemberCardInfo.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
                
                  that.ruleForm  = res.data
                  that.ruleForm.CardNumber=res.data.Kynumber;
                  that.ruleForm.buyCount=res.data.Kynumber;
                  that.ruleForm.CardDays=res.data.yxdays;
                  that.ruleForm.Amount=res.data.Amount;
                  that.ruleForm.PurchaseAmount=res.data.SellingPrice;
                  that.ruleForm.YSAmount=res.data.SellingPrice;
                  that.ruleForm.zsCardNumber=0;
       

                   that.Note = ''
                   var date = new Date();
                  var year=date.getFullYear();
                  var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                  var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                  that.ruleForm.GMtime = year + '-' + month + '-' + day
            } 

        })
      // var CardType = this.ruleForm.CardType
      if(this.ruleForm.CardType==1 ||this.ruleForm.CardType==3 ||this.ruleForm.CardType==5){
                      var date = new Date(it.OverdueTime);//比如sourceDate传参“2019-03-31”)
                      // console.log(val.CardDays)
                      if(this.ruleForm.dayType == 1){
                        var buycount = parseInt(this.ruleForm.daysvalue);
                        date.setDate(date.getDate() + buycount - 1);
                        var year=date.getFullYear();
                        var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                        var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                        this.ruleForm.EndTime = year+"-"+month+"-"+day;
                      }
                      if(this.ruleForm.dayType == 2){
                      var buycount = parseInt(this.ruleForm.daysvalue);
                        // date.setDate(date.getDate() + 0);
                        date.setMonth(date.getMonth()+ buycount);
                        date.setDate(date.getDate()  - 1);
                        var year=date.getFullYear();
                        var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                        var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                        this.ruleForm.EndTime = year+"-"+month+"-"+day;
                      }
                      if(this.ruleForm.dayType == 3){
                        var buycount = parseInt(this.ruleForm.daysvalue);
                        date.setDate(date.getDate() -1);
                        var year=date.getFullYear() + buycount;
                        var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                        var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                        this.ruleForm.EndTime = year+"-"+month+"-"+day;
                      }
                   
                  
      }
      this.xuEndTime =this.ruleForm.EndTime;
          
            this.xukashow = true
    },

    editMembersvipiskaikaClick(items){
      this.items =items;
      if(items.iskaika == 1){
           this.cardTitle = '修改开卡时间'
      } else{
          this.cardTitle = '开卡'
      }
     
      this.Note = ''
      this.mainShow = true
    },
    editMembersvipAmounteClick(items){
              this.items = items;
 this.Note = ''
                this.showDrawerAmount =true;

  },
    xiaokeClick(items){
      this.items = items;
      this.cardTitle = this.name2
      this.Note = ''
      this.num = 1
      this.singlePrice = 1
      this.mainShow = true
    },
    editMembersvipCardDaysClick(items){
      this.items = items;
      this.cardTitle = '修改到期时间'
      this.Note = ''
      this.mainShow = true
    },addvipJYZQClick(items){
     this.items = items;
      this.yyJYtitle = '设置周期限制-'+items.CardName;
      var arr = items.JYCycle.split(',');
                        if(arr.length>0){
                        this.checkedCycles = arr;
                        }
        
                this.yyZYShow =true;
    },handleChange(val,item){
                // console.log(val)
                this.JYCycle = val.join();
                // console.log(this.ruleForm.Cycle)
            },submityyJYForm(){
      var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          vipID:this.items.ID,
          JYCycle:this.JYCycle 
        }
        var that = this
        this.ajax('editMembersvipJYCycle.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });

              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              that.yyZYShow =false;
            }

        })
    },
    editMembersvipweekdaysClick(items){
     this.items = items;
      this.cardTitle = '修改一周预约次数'
      this.Note = ''
      this.num = 1,
      this.mainShow = true
    },
    editMembersvipCardNumberClick(items){
      this.items = items;
      this.cardTitle = '修改次数'
      this.Note = ''
      this.mainShow = true
    },
    editMembersvipisStopClick1(items){
      this.items = items
      this.cardTitle = '解除停卡'
      this.Note = ''
      this.mainShow = true
    },
    editMembersvipisStopClick(items){
      this.items = items
      this.Note = '';
      this.cardTitle = '停卡'
      this.mainShow = true
    },
    editMembersvipIsdisableClick(ID){
      this.$confirm("确定要禁用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:ID,
          sourceID:localStorage.getItem("LoginID"),
          sourceName:localStorage.getItem("Name"),
          Isdisable:1,
        }
        var that = this
        this.ajax('editMembersvipIsdisable.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "禁用成功",duration:2000,
              });
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              //  that.provinceList = res.data
            }

        })

        })
        .catch(() => {
          
        });
   
    },
    editMembersvipIsdisableClick1(ID){
      this.$confirm("确定要启用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:ID,
          sourceID:localStorage.getItem("LoginID"),
          sourceName:localStorage.getItem("Name"),
          Isdisable:0,
        }
        var that = this
        this.ajax('editMembersvipIsdisable.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "启用成功",duration:2000,
              });
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              //  that.provinceList = res.data
            }

        })

        })
        .catch(() => {
         
        });
   
    },
    sure(){
      if(this.cardTitle == '修改备注'){
        this.editNote()
      }
      if(this.cardTitle == '停卡'){
        this.tingka()
      }
      if(this.cardTitle == '解除停卡'){
        this.jiechutingka()
      }
      if(this.cardTitle == '修改次数'){
        this.xiugaicishu()
      }
      if(this.cardTitle == '修改到期时间'){
        this.xiugaiTime()
      }
      if(this.cardTitle == this.name2){
        this.xiaoke()
      }
      if(this.cardTitle == '修改一周预约次数'){
        this.yuekecishu()
      }
      if(this.cardTitle == '修改开卡时间' ||this.cardTitle == '开卡' ){
        this.kaika()
      }
      
    },
    yuekecishu(){
       var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:this.items.ID,
          Note:this.Note,
          LoginID:localStorage.getItem("LoginID"),
          weekdays:this.num
        }
        var that = this
        this.ajax('editMembersvipWeekdays.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              //  that.provinceList = res.data
            }

        })
    },
    xiaoke(){
        var data = { 
          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          vipID:this.items.ID,
          Note:this.Note,
          LoginID:localStorage.getItem("LoginID"),
          ConsumptionOfClass:this.num,
          singlePrice:this.singlePrice
        }
        var that = this
        this.ajax('editStuVipState.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "操作成功",duration:2000,
              });
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              that.getHeXiao3()
              //  that.provinceList = res.data
            }

        })
    },
    kaika(){
       var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:this.items.ID,
          OverdueTime:this.items.OverdueTime,
          Note:this.Note,
          KaiKaTime:this.items.KaiKaTime,
          sourceID:localStorage.getItem("LoginID"),
          sourceName:localStorage.getItem("Name")  
        }
        var that = this
        this.ajax('editMembersvipKaiKaTime.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              //  that.provinceList = res.data
            }

        })
    },
      handlebang(){
      this.$confirm("确定要解绑微信吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
            MembersID:this.list.ID,
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token")
        }
        var that = this
        this.ajax('wxjiebang.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "解绑成功",duration:2000,
              });
                    
              // that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
    },
    xiugaiTime(){
        var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:this.items.ID,
          OverdueTime:this.items.OverdueTime,
          Note:this.Note,
          sourceID:localStorage.getItem("LoginID"),
          sourceName:localStorage.getItem("Name")  
        }
        var that = this
        this.ajax('editMembersvipOverdueTime.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              //  that.provinceList = res.data
            }

        })
    },
       submitFormAmountClass(){
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:this.items.ID,
          Note:this.Note,
          Amount:this.items.Amount,
          Note:this.Note,
          sourceID:localStorage.getItem("LoginID"),
          sourceName:localStorage.getItem("Name")  
        }
        var that = this
        this.ajax('editMembersvipAmount.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
              that.showDrawerAmount =false
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              //  that.provinceList = res.data
            }

        })
    },
    xiugaicishu(){
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:this.items.ID,
          Note:this.Note,
          CardNumber:this.items.CardNumber,
          Note:this.Note,
          sourceID:localStorage.getItem("LoginID"),
          sourceName:localStorage.getItem("Name")  
        }
        var that = this
        this.ajax('editMembersvipCardNumber.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              //  that.provinceList = res.data
            }

        })
    },
    jiechutingka(){
        var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:this.items.ID,
          Note:this.Note,
          isStop:0,
          OverdueTime:this.items.kaiOverdueTime,
          Note:this.Note,
          sourceID:localStorage.getItem("LoginID"),
          sourceName:localStorage.getItem("Name")  
        }
        var that = this
        this.ajax('editMembersvipOnisStop.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "解除停卡成功",duration:2000,
              });
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              //  that.provinceList = res.data
            }

        })
    },
    tingka(){
       var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:this.items.ID,
          Note:this.Note,
          isStop:1,
          StopTime:this.items.StopTime,
          Note:this.Note,
          sourceID:localStorage.getItem("LoginID"),
          sourceName:localStorage.getItem("Name")  ,
          isStopType:this.items.isStopType,
          StopDays:this.items.StopDays, 
        }
        var that = this
        this.ajax('editMembersvipisStop.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "停卡成功",duration:2000,
              });
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              //  that.provinceList = res.data
            }

        })
    },
    editNote(){
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:this.items.ID,
          Note:this.Note,
          sourceID:localStorage.getItem("LoginID"),
          sourceName:localStorage.getItem("Name")  
        }
        var that = this
        this.ajax('editMembersvipNote.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              //  that.provinceList = res.data
            }

        })
    },
    editMembersvipNoteClick(items){
      this.items = items
      this.Note = this.items.Note
      this.cardTitle = '修改备注'
      this.mainShow = true
    },
    delMembersvipClick(ID){
       this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersvipID:ID,
        
        }
        var that = this
        this.ajax('delMembersvip.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
              that.cardMain = false
              that.getListMembersvip()
              that.getList()
              that.closeDialog()
              that.getCardMain()
              //  that.provinceList = res.data
            }

        })

        })
        .catch(() => {
            ;
        });
   
    },
    toMain(items){
      this.cardMain = true
      this.vipitem = items
      this.getCardMain()
        this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      }
      if(this.iscdyy==1){
      this.activeName1 = '4'
      this.getHeXiao4()

      }else{
        if(this.iszjyy==1){
          this.activeName1 = '1'
      this.getHeXiao2()

        }else{
          this.activeName1 = '0'
      this.getHeXiao1()

        }

      }
           
      
    },
    getCardMain(){
      if(this.vipitem !=''){
 var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          vipID:this.vipitem.ID
      }
    var that = this

      this.ajax('getMembersvipInfo.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                  
                that.vipitem = res.data
                that.vipitem.OverdueTime = that.vipitem.OverdueTime.replace(/\//g, '-')

          } 

      })
    
      }
     
    },
    toVip(){
        this.$router.go(-1)
    },
    getTeachList(){
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          StaffTypeID:0
      }
    var that = this

      this.ajax('getListStaff.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
        
                that.TeacherList = res.data
      
          } 

      })
    },
    inputSubtotal(val){

                    if(val !=''){
                           if(val.CardType==1 || val.CardType==3|| val.CardType==5){
                    var date = new Date(val.KaiKaTime);//比如sourceDate传参“2019-03-31”
                     var buycount = parseInt(val.CardDays);

                     date.setDate(date.getDate() + buycount);
                    var year=date.getFullYear();
	     	            var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
	    	              var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                      val.EndTime = year+"-"+month+"-"+day;
                    }
                  }
              
                },inputSubtotalxk1(val){
                  if(val !=''){
                    console.log(val.EndTime)
                   var zsdaysvalue =this.ruleForm.zsdaysvalue;

                   var EndTime  =this.xuEndTime;
                   if(zsdaysvalue=='' || typeof(zsdaysvalue) == "undefined"){
                     zsdaysvalue =0;
                   }
                   console.log('zsdaysvalue',zsdaysvalue)

                   if(val.CardType==1 || val.CardType==3 || val.CardType==5){
                   var date = new Date(EndTime);//比如sourceDate传参“2019-03-31”)
                   console.log('date',date)

                   // console.log(val.CardDays)
                   if(this.ruleForm.zsdayType == 1){
                     var buycount = parseInt(zsdaysvalue);
                      date.setDate(date.getDate() + buycount - 1);
                    


                     var year=date.getFullYear();
                     var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                     var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                     val.EndTime = year+"-"+month+"-"+day;
                   }
                    if(this.ruleForm.zsdayType == 2){
                     var buycount = parseInt(zsdaysvalue);
                       // date.setDate(date.getDate() + 0);
                     date.setMonth(date.getMonth()+ buycount);
                    
                     date.setDate(date.getDate()  - 1);
                     var year=date.getFullYear();
                     var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                     var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                     val.EndTime = year+"-"+month+"-"+day;
                   }
                    if(this.ruleForm.zsdayType == 3){
                     var buycount = parseInt(zsdaysvalue);

                      date.setDate(date.getDate() -1);
                      
                     var year=date.getFullYear() + buycount;
                     var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                     var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                     val.EndTime = year+"-"+month+"-"+day;
                   }
                   // var buycount = parseInt(val.CardDays);
                
               }
                 } 
                },inputSubtotal1(val){
                  if(val !=''){
                   
                    var zsdaysvalue =this.ruleForm.zsdaysvalue;
                    if(zsdaysvalue=='' || typeof(zsdaysvalue) == "undefined"){
                      zsdaysvalue =0;
                    }
                    if(val.CardType==1 || val.CardType==3 || val.CardType==5){
                    var date = new Date(val.KaiKaTime);//比如sourceDate传参“2019-03-31”)
                    // console.log(val.CardDays)
                    if(this.ruleForm.dayType == 1){
                      var buycount = parseInt(this.ruleForm.daysvalue);
                       date.setDate(date.getDate() + buycount - 1);
                       if(this.ruleForm.zsdayType == 1){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setDate(date.getDate() + buycount1);

                       }else if(this.ruleForm.zsdayType == 2){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setMonth(date.getMonth()+ buycount1);

                       }else if(this.ruleForm.zsdayType == 3){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setFullYear(date.getFullYear() + buycount1);

                       }


                      var year=date.getFullYear();
                      var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                      var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                      val.EndTime = year+"-"+month+"-"+day;
                    }
                     if(this.ruleForm.dayType == 2){
                      var buycount = parseInt(this.ruleForm.daysvalue);
                        // date.setDate(date.getDate() + 0);
                      date.setMonth(date.getMonth()+ buycount);
                      if(this.ruleForm.zsdayType == 1){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setDate(date.getDate() + buycount1);

                       }else if(this.ruleForm.zsdayType == 2){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setMonth(date.getMonth()+ buycount1);

                       }else if(this.ruleForm.zsdayType == 3){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setFullYear(date.getFullYear() + buycount1);

                       }
                      date.setDate(date.getDate()  - 1);
                      var year=date.getFullYear();
                      var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                      var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                      val.EndTime = year+"-"+month+"-"+day;
                    }
                     if(this.ruleForm.dayType == 3){
                      var buycount = parseInt(this.ruleForm.daysvalue);
 
                       date.setDate(date.getDate() -1);
                       if(this.ruleForm.zsdayType == 1){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setDate(date.getDate() + buycount1);

                       }else if(this.ruleForm.zsdayType == 2){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setMonth(date.getMonth()+ buycount1);

                       }else if(this.ruleForm.zsdayType == 3){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setFullYear(date.getFullYear() + buycount1);

                       }
                      var year=date.getFullYear() + buycount;
                      var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                      var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                      val.EndTime = year+"-"+month+"-"+day;
                    }
                    // var buycount = parseInt(val.CardDays);
                 
                }
                  } 
                },
               selectData1(val){
               
                if(val.CardType==1 || val.CardType==3 || val.CardType==5){
                    var date = new Date(val.KaiKaTime);//比如sourceDate传参“2019-03-31”)
                    var zsdaysvalue =this.ruleForm.zsdaysvalue;
                    if(zsdaysvalue=='' || typeof(zsdaysvalue) == "undefined"){
                      zsdaysvalue =0;
                    }
                    // console.log(val.CardDays)
                    if(this.ruleForm.dayType == 1){
                      var buycount = parseInt(this.ruleForm.daysvalue);
                       date.setDate(date.getDate() + buycount - 1);
                       if(this.ruleForm.zsdayType == 1){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setDate(date.getDate() + buycount1);

                       }else if(this.ruleForm.zsdayType == 2){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setMonth(date.getMonth()+ buycount1);

                       }else if(this.ruleForm.zsdayType == 3){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setFullYear(date.getFullYear() + buycount1);

                       }


                      var year=date.getFullYear();
                      var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                      var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                      val.EndTime = year+"-"+month+"-"+day;
                    }
                     if(this.ruleForm.dayType == 2){
                      var buycount = parseInt(this.ruleForm.daysvalue);
                        // date.setDate(date.getDate() + 0);
                      date.setMonth(date.getMonth()+ buycount);
                      if(this.ruleForm.zsdayType == 1){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setDate(date.getDate() + buycount1);

                       }else if(this.ruleForm.zsdayType == 2){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setMonth(date.getMonth()+ buycount1);

                       }else if(this.ruleForm.zsdayType == 3){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setFullYear(date.getFullYear() + buycount1);

                       }
                      date.setDate(date.getDate()  - 1);
                      var year=date.getFullYear();
                      var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                      var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                      val.EndTime = year+"-"+month+"-"+day;
                    }
                     if(this.ruleForm.dayType == 3){
                      var buycount = parseInt(this.ruleForm.daysvalue);
 
                       date.setDate(date.getDate() -1);
                       if(this.ruleForm.zsdayType == 1){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setDate(date.getDate() + buycount1);

                       }else if(this.ruleForm.zsdayType == 2){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setMonth(date.getMonth()+ buycount1);

                       }else if(this.ruleForm.zsdayType == 3){
                        var buycount1 = parseInt(zsdaysvalue);
                        date.setFullYear(date.getFullYear() + buycount1);

                       }
                      var year=date.getFullYear() + buycount;
                      var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                      var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                      val.EndTime = year+"-"+month+"-"+day;
                    }
                    // var buycount = parseInt(val.CardDays);
                 
                }

            },
    changebangka1(val){

                this.ruleForm.Isbangka = val;
            },
    changebangka(val){
               if(val=='1'){
                    this.showCardID=true;
               }else{
                this.showCardNum=false;
                this.showPurchaseAmount=false;
                this.showKynumber= false;
                this.showyxdays=false;
                this.showAmount=false;
                this.isEdit = false;
                this.showCardID=false;

               }
            },
    changeCardID1(val){
                console.log(val)
                this.ruleForm.KaiKaTime = ''
                this.ruleForm.EndTime = ''
                  let arr1 = val.split(",");
                  // console.log(arr1)
                  if(arr1.length > 6){
                  this.ruleForm.CardID = arr1[0];
                  this.ruleForm.CardType = arr1[1];
                  this.ruleForm.CardName = arr1[2];
                  this.ruleForm.CardNumber = arr1[3];
                  this.ruleForm.buyCount = arr1[3];

                  this.ruleForm.CardDays = arr1[4];
                  this.ruleForm.Amount = arr1[5];
                  this.ruleForm.PurchaseAmount = arr1[6];
                  this.ruleForm.YSAmount = arr1[6];
                  this.ruleForm.dayType = arr1[7];
                  this.ruleForm.daysvalue = arr1[8];
      
                this.showCardNum=true;
                this.showPurchaseAmount=true;

                let CardType = arr1[1];

                if(CardType == 1){
                this.showKynumber= true;
                this.showyxdays=true;
                this.showAmount=false;


                }else if(CardType  ==2){
                this.showKynumber= true;
                this.showyxdays=false;
                this.showAmount= false;

                }else if(CardType  ==3){
                this.showKynumber= false;
                this.showyxdays= true;
                this.showAmount=false;

                }else if(CardType  ==4){

                this.showKynumber= false;
                this.showyxdays=false;
                this.showAmount= true;      
                this.zhekou  = 0          

                }else if(CardType  ==5){

                this.showKynumber= false;
                this.showyxdays=true;
                this.showAmount= true;                
                this.zhekou  = 0  
                }
                
                }
    

            },
            getMyhyq(){
               var data = { 
                SelectStoresID:this.SelectStoresID,
                token: localStorage.getItem("token"),
                StoresID:localStorage.getItem("StoresID"),
                MembersID:this.$route.params.id,
                yfjine: this.ruleForm.PurchaseAmount,
                CardID:this.ruleForm.CardID,
             }
        var that = this
        this.ajax('getListCouponMemberSY.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
                that.myyhqList = res.data

            }
      })
            },
    toGiveCard(){

        this.title = '发卡'
     
        this.ruleForm={
                    StoresID: "",
                    OpenTime:"",
                    Birthday:"",
                    Address: "",
                    Note: "",
                    isSource:"1",
                    Sex: "1",
                    Isbangka: "1",
                    CardNum:"",
                    CardNumber:"",
                    CardDays:"",
                    Amount:"",
                    CardID:"",
                    CardName:"",
                    CardType:"",
                    PurchaseAmount:"",
                    iskaika:"1",
                    isyhq:'0',
                    KaiKaTime:"",
                    EndTime:"",
                    isjiebang:0,
                    isaddzi:0,
                    iscz:0,
                    LoginID:"",
                    buyCount:"" ,
                    YSAmount:"" ,
                    GMtime:"" ,
                    daysvalue:"" ,
                    dayType:"" ,
                    zsCardNumber:"0" ,
                    zsdaysvalue:"0" ,
                    zsdayType:1,
                    zsAmount:"0" ,
      }
      var date = new Date();
        var year=date.getFullYear();
	     	var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
	    	var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
        this.ruleForm.GMtime = year + '-' + month + '-' + day
        this.cardShow = true

    },
    handleClick(){

      console.log(this.activeName)
       this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      }
    if(this.activeName  == 0){
      this.getListMembersvip()
    } 
    if(this.activeName  == 1){
      this.getListMembersPreAboutZJ()
    } 
    if(this.activeName  == 2){
      this.getListMembersPreAbout()
    }
    if(this.activeName ==3){
      this.getListMembersPayOrder()
    }
    if(this.activeName ==4){
      this.getSubList()
    }
    if(this.activeName ==5){
      this.getjifen()
     }
    if(this.activeName ==6){
      this.getTc()
     }
    },
   
    handleClick1(){

       this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      }
    if(this.activeName1  == 0){
      this.getHeXiao1()
      } 
    if(this.activeName1  == 1){
      this.getHeXiao2()
      } 
    if(this.activeName1  == 2){
      this.getHeXiao3()
     }
     if(this.activeName1  == 4){
      this.getHeXiao4()
     }
    },
getHeXiao4(){
      var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.$route.params.id,
          MembersvipID:this.vipitem.ID,
          pages:this.formInline.page,
          psize:this.formInline.limit
        }
        var that = this
       this.ajax('getListMembersvipCDQDJL.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              
               that.hexiaoList =res.data      
              that.pageparm.total = res.allcount
            }
      })
},
getHeXiao1(){
      var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.$route.params.id,
          MembersvipID:this.vipitem.ID,
          pages:this.formInline.page,
          psize:this.formInline.limit
        }
        var that = this
       this.ajax('getListMembersvipQDJL.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
                res.data.forEach(items => {
                 items.SKtime = items.SKtime.replace(/\//g, '-')
               });
               that.hexiaoList =res.data      
              that.pageparm.total = res.allcount
            }
      })
},
getHeXiao2(){
      var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.$route.params.id,
          MembersvipID:this.vipitem.ID,
          pages:this.formInline.page,
          psize:this.formInline.limit
        }
        var that = this
       this.ajax('getListMembersvipZJQDJL.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
                res.data.forEach(items => {
                 items.addTime = items.addTime.replace(/\//g, '-')
               });
               that.hexiaoList =res.data      
                that.pageparm.total = res.allcount
            }
      })
},
getHeXiao3(){
      var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.$route.params.id,
          MembersvipID:this.vipitem.ID,
          pages:this.formInline.page,
          psize:this.formInline.limit
        }
        var that = this
       this.ajax('getListAdminHypeXK.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.hexiaoList =res.data      
                that.pageparm.total = res.allcount
            }
      })
},
    uploadPicture(name) {
      this.timer = new Date().getTime()
      this.cropperName = name;
      this.cropperModel = true;
    },
    handleUploadSuccess(data) {
      this.cropperModel = false
      this.editForm.HeadUrl = data.url
 
    },
    handleDetail(row){

        this.$router.push({ path: '/vip/vipDetail'})

    },
    getList1(){

    //  this.tableLoading = true
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          StaffTypeID:''
      }
     
      
      var that = this
      this.ajax('getlistStaffgl.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.personList = res.data
          } 

      })
  
  
    },
    forceUpdate(){
      this.$forceUpdate()
    },
    deleteYhq(row){
      
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
           SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          CouponMemberID:row.ID,
          isdel:1,
        }
        var that = this
        this.ajax('editCouponMemberisdel.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
               that.formInline.page = 1
              that.getTc()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
    },
    deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersID:row.ID,
        
        }
        var that = this
        this.ajax('delMembers.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
              that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
    getType(){
       var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CardType:0,
      }
      var that = this
      this.ajax('getListMemberCard.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
       
                that.typeList = res.data
                //  loading.close();
          } 
       })
    
    },
    getListMembersvip(){

        var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.$route.params.id
      }

      var that = this
      this.ajax('getListMembersvip.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                res.data.forEach(items => {
                    items.OverdueTime = items.OverdueTime.replace(/\//g, '-')
                });
                that.cardList = res.data
             
          } 

      })
    },
    getList(){
        console.log(this.$route.params)
       var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.$route.params.id
         
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
      var that = this
      this.ajax('getMembersinfo.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.list = res.data
                that.list.OpenTime =  that.list.OpenTime.replace(/\//g, '-')
                 loading.close();
          } 

      })
  
    },
    handlePassword(row){
      this.editForm.ManageLoginID = row.ID
      this.Pwd = ''
      this.passShow = true

    },
    handleCi(row){
      if(row == 1){
        this.id = this.list.ID
        this.chongCi1 = true
        this.number = ''
        this.Note=''
         this.GMAmount = ''
        this.personName = this.list.StaffName
        this.StaffID = this.list.StaffID
          var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month < 10) {
            month = '0' + month;
            }
            if (day < 10) {
            day = '0' + day;
            }
          var nowDate = year + '-' + month + '-' + day;
          this.GMtime = nowDate
      } else {
        this.id = this.list.ID
        this.chongCi = true
        this.number = ''
        this.Note=''
       

      }
      
    },
    handleChong(row){
      if(row == 1){
        this.id = this.list.ID
        this.chongShow1 = true
        this.money = ''
        this.Note=''
          this.GMAmount = ''
        this.personName = this.list.StaffName
        this.StaffID = this.list.StaffID
          var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month < 10) {
            month = '0' + month;
            }
            if (day < 10) {
            day = '0' + day;
            }
          var nowDate = year + '-' + month + '-' + day;
          this.GMtime = nowDate
      } else {
         this.id = this.list.ID
        this.chongShow = true
        this.money = ''
        this.Note=''
      }
      
    },
        ADDCi(){
         var data = {
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          LoginID:localStorage.getItem('LoginID'),
          MembersID:this.id,
          syNumber:this.number,
          Note:this.Note,

      }
        var that = this
        this.ajax('editMemberssyNumberXK.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
     
                that.tableData = res.data
     
               that.$message({
                            type: "success",
                            message: "扣次成功",duration:2000,
                  });
            that.chongCi = false
            that.getList()
          } 

      })
    },
    ADDmoney1(){
         var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          LoginID:localStorage.getItem('LoginID'),
          MembersID:this.id,
          czAmount:this.money,
          Note:this.Note,
            GMAmount:this.GMAmount,
          StaffID:this.StaffID,
          GMtime:this.GMtime,

      }
        var that = this
        this.ajax('editMembersczAmount.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
     
                that.tableData = res.data
     
               that.$message({
                      type: "success",
                      message: "充值成功",duration:2000,
                });
            that.chongShow1 = false
            that.getList()
          } 

      })
    },
    ADDCi1(){
         var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          LoginID:localStorage.getItem('LoginID'),
          MembersID:this.id,
          syNumber:this.number,
          Note:this.Note,
          GMAmount:this.GMAmount,
          StaffID:this.StaffID,
          GMtime:this.GMtime,
      }
        var that = this
        this.ajax('editMemberssyNumber.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.tableData = res.data
              that.$message({
                            type: "success",
                            message: "充值成功",duration:2000,
                  });
            that.chongCi1 = false
            that.getList()
          } 

      })
    },
    ADDmoney(){
         var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          LoginID:localStorage.getItem('LoginID'),
          MembersID:this.id,
          czAmount:this.money,
          Note:this.Note,

      }
        var that = this
        this.ajax('editMembersczAmountXK.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
     
                that.tableData = res.data
     
               that.$message({
                            type: "success",
                            message: that.name2+"成功",duration:2000,
                  });
            that.chongShow = false
            that.getList()
          } 

      })
    },
    // 获取公司列表

    // 分页插件事件
    callFatherYhq(){
      this.formInline4.page = parm.currentPage
      this.formInline4.limit = parm.pageSize
      this.getAllTc()
    },
    callFather2(parm){
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.giveCardList()
    
    },
    callFather3(parm){
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getCi()
    
    },
    callFather11(parm){
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      if(this.activeName1  == 0){
      this.getHeXiao1()
    } 
    if(this.activeName1  == 1){
      this.getHeXiao2()
    }
    if(this.activeName1 ==2){
      this.getHeXiao3()
    }
    if(this.activeName1 ==4){
      this.getHeXiao4()
    }
    },
    callFather1(parm){
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      if(this.activeName  == 1){
      this.getListMembersPreAboutZJ()
    } 
    if(this.activeName  == 2){
      this.getListMembersPreAbout()
    }
    if(this.activeName ==3){
      this.getListMembersPayOrder()
    }
     if(this.activeName ==5){
      this.getjifen()
    }
    if(this.activeName ==6){
      this.getTc()
    }
    },
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.tojilu()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(row) {
      
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm = row
        this.editForm.Sex = Number(this.editForm.Sex) 
        if(this.editForm.LevelID == 0 ){
           this.editForm.LevelID =''
         }
      } else {

        this.editForm={
            LoginName:"",
            Phone:"",
            Name:"",
            pwd:"",
            money:"",
                ShopName:"",
                HeadUrl:'',
                Sex:1,
                Address:'',
                Birthday:'2000-10-10',
                OpenTime:'',
                LevelID:'',
                StaffID:'',

        }
          var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
          var nowDate = year + '-' + month + '-' + day;
          this.editForm.OpenTime = nowDate
           this.title = '添加'
   
        //  this.editForm.ManageLoginID = ''
        // this.editForm.LoginName = ''
        // this.editForm.Phone= ''
        // this.editForm.Name= ''
        // this.editForm.ShopName= ''
        // this.editForm.pwd=''
        // this.editForm.money=' '

      }
    },




    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
            var that = this
            var data = this.ruleForm
            data.Discountcx = this.zhekou * 10
            if(this.ruleForm.isyhq == 1){
              data.PurchaseAmount = this.yhmoney
              data.CouponMemberID = this.myyhq.ID
            }
            data.SelectStoresID  = this.SelectStoresID 
            data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")
            data.sourceID = localStorage.getItem("LoginID")  
            data.sourceName = localStorage.getItem("Name")  
            data.MembersID = this.$route.params.id
            if(this.title == '发卡'){
              if(this.ruleForm.KaiKaTime == '' && this.ruleForm.iskaika == 1){
                    this.$message({

                            message: "请选择开卡日期",

                    });  
              } else {
              this.ajax('addMembersvip.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                            that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                          });
                          that.personName = ''
                        that.cardShow = false
                        that.getList()
                        that.formInline.page = 1
                        that.getTc()
                        that.getListMembersvip()
                        // this.getType()
                        //   this.getTeachList()
                      }

                  })

              }

               

            }else {
              data.MembersID = this.editForm.ID
             this.ajax('editMembers.aspx',JSON.stringify(data),"POST",function(res){
                     if (res.orsuccess == "1") {
                              that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000,
                                  });
                                  that.editFormVisible = false
                                  that.getList()
                                }                                 

                    })         

            }
        } else {
          return false
        }
      })
  
    
    },
submitForm1(){
  var that = this
  var data = this.editForm
  data.token=localStorage.getItem("token")
  data.StoresID=localStorage.getItem("StoresID")
   data.MembersID = this.editForm.ID
   data.SelectStoresID  = this.SelectStoresID 
   this.ajax('editMembers.aspx',JSON.stringify(data),"POST",function(res){
                     if (res.orsuccess == "1") {
                              that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000,
                                  });
                                  that.editFormVisible = false
                                  that.getList()
                                  that.getListMembersvip()
            }                                 

  })         

            
},

closeDialog1(){
  this.mainShow = false
},
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.cardShow = false
      this.xukashow = false
      // this.cardMain = false
      this.mainShow = false
      // this.passShow = false,
      // this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
:vertical{
  z-index: 99;
}
.fiex{

  width:100%;
  background: white;
  margin-top: -20px !important;
  height: 50px;
}

.card{
   width: 20%;
    height: 112px;
    background-color: #f2f2f2;
    border-radius: 3px;
}
.labele{
    font-size: 16px;
}
.diss{
  display: flex;
  flex-wrap: wrap;
}
.tiao{
    margin-top: 3px;
    width: 49.5%;
    height: 35px;
    margin-left:0.4%;
    border-radius: 3px;
    background-color: #f2f2f2;
}
.mainClass{
  margin-top:10px;
  background-color: white;
  width:90%;
  margin-left:5%;
  
  
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/vip/vipDetail.vue